<div class="row main-content">
    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-2">
        <div class="sidebar">
            <ul>
                <li routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li class="active1" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || !isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li routerLink="/dashboard/Save-Quotes"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li routerLink="/dashboard/forms"><img src="./assets/images/file-text.svg"><a>FORMS</a></li>
                <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li>
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li routerLink="/dashboard/resources"><img src="./assets/images/resources.svg"><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
        <div *ngIf="showChooseQuote" class="whitebox p-3 posFixed">
            <label class="bold fs-18 m-0">Select one or more plans to be quoted</label>
        </div>
        <div *ngIf="showSendSaveQuoteEmail" class="whitebox p-3 posFixed">
            <label class="bold fs-18 m-0">Email Quote</label>
        </div>
        <div *ngIf="showIntStudPlan" class="posFixed bgf2">
            <div class="row borderbottom">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 borderRight pl-2 pt-2" [ngClass]="{'borderbottomRed': showIntStudPlanStep1==true}">
                    <div class="d-flex">
                            <div class="numberBox bold">
                                <div class="align-center">1</div>
                            </div>
                            <div class="semi-bold stagePadding fs-14 lh-n" (click)="gotBackToIntStudPlan()">Enter Your Trip Details</div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 borderRight pl-2 pt-2" [ngClass]="{'borderbottomRed': showIntStudPlanPlanOption==true || showQuestionnaire==true}">
                    <div class="d-flex">
                        <div class="numberBox bold">
                            <div class="align-center">2</div>
                        </div>
                        <div class="semi-bold stagePadding fs-14 lh-n" *ngIf="step2headerclick==false">Select an Insurance Plan</div>
                        <div class="semi-bold stagePadding fs-14 lh-n" *ngIf="step2headerclick==true" (click)="gotBackToQuestionnaire()">Select an Insurance Plan</div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 borderRight pl-2 pt-2" [ngClass]="{'borderbottomRed': showContactInfo==true}">
                    <div class="d-flex">
                        <div class="numberBox bold">
                            <div class="align-center">3</div>
                        </div>
                        <div class="semi-bold stagePadding fs-14 lh-n" *ngIf="step3headerclick==false">Enter Each Insured’s Information</div>
                        <div class="semi-bold stagePadding fs-14 lh-n" *ngIf="step3headerclick==true" (click)="gotBackToContactInfo()">Enter Each Insured’s Information</div>
                    </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 pl-2 pt-2" [ngClass]="{'borderbottomRed': showPayment==true}">
                    <div class="d-flex">
                        <div class="numberBox bold">
                            <div class="align-center">4</div>
                        </div>
                        <div class="semi-bold stagePadding fs-14 lh-n" *ngIf="step4headerclick==false">Contact and Payment Info</div>
                        <div class="semi-bold stagePadding fs-14 lh-n" *ngIf="step4headerclick==true" (click)="showPaymentpage()">Contact and Payment Info</div>
                    </div>
                </div>
            </div>
            <!-- <label *ngIf="showIntStudPlanStep1" class="bold fs-18 m-0">Quote Info: <span class="red5">International Student Plan</span></label>
            <label *ngIf="showIntStudPlanPlanOption" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gotBackToIntStudPlan()">International Student Plan</span><span class="red5">&nbsp;>&nbsp;Plan Options</span></label>
            <label *ngIf="showQuestionnaire" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gotBackToIntStudPlan()">International Student Plan</span><span class="cp" (click)="gotBackToIntStudPlanOption()">&nbsp;>&nbsp;Plan Options</span><span class="red5">&nbsp;>&nbsp;Questionnaire</span></label>
            <label *ngIf="showContactInfo" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gotBackToIntStudPlan()">International Student Plan</span><span class="cp" (click)="gotBackToIntStudPlanOption()">&nbsp;>&nbsp;Plan Options</span><span class="cp" (click)="gotBackToQuestionnaire()">&nbsp;>&nbsp;Questionnaire</span><span class="red5">&nbsp;>&nbsp;Contact Info.</span></label>
            <label *ngIf="showPayment || showPaymentsDetails" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gotBackToIntStudPlan()">International Student Plan</span><span class="cp" (click)="gotBackToIntStudPlanOption()">&nbsp;>&nbsp;Plan Options</span><span class="cp" (click)="gotBackToQuestionnaire()">&nbsp;>&nbsp;Questionnaire</span><span class="cp" (click)="gotBackToContactInfo()">&nbsp;>&nbsp;Contact Info.</span><span class="red5">&nbsp;>&nbsp;Payment</span></label>
            <label *ngIf="showStudAccidentInsureStep1" class="bold fs-18 m-0">Quote Info: <span class="red5">Student Accident Insurance</span></label>
            <label *ngIf="showStudAccidentInsurePlanOption" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gobackToSAIStep1()">Student Accident Insurance</span><span class="red5">&nbsp;>&nbsp;Plan Options</span></label>
            <label *ngIf="showContactInfoStudAccidentInsure" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gobackToSAIStep1()">Student Accident Insurance</span><span class="cp" (click)="gobackToSAIPlanOption()">&nbsp;>&nbsp;Plan Options</span><span class="red5">&nbsp;>&nbsp;Contact Info.</span></label>
            <label *ngIf="showPaymentStudAccidentInsure || showPaymentsDetailsStudAccidentInsure" class="bold fs-18 m-0">Quote Info: <span class="cp" (click)="gobackToSAIStep1()">Student Accident Insurance</span><span class="cp" (click)="gobackToSAIPlanOption()">&nbsp;>&nbsp;Plan Options</span><span class="cp" (click)="gotBackToContactInfoSAI()">&nbsp;>&nbsp;Contact Info.</span><span class="red5">&nbsp;>&nbsp;Payment</span></label> -->
        </div>
        <div class="clear40"></div>
        <div class="clear20"></div>
        <div class="h100" *ngIf="showIntStudPlan">
            <div class="clear10"></div>
            <div class="" *ngIf="showIntStudPlanStep1">
                <div class="conclass">
                    <div class="row">
                        <div class="col-lg-3 mycontent-right">
                            <label for="" class="bold fs-18">TRIP INFORMATION</label>
                            <div class="clear"></div>
                            <label class="lbl1">Is this for a Super Visa?<span class="redstar">*</span></label>
                            <div class="row">
                                <div class="ml-0">
                                    <input type="radio" id="true" name="selectedStatus" [(ngModel)]="selectedStatus" (change)="superVisaChange(selectedStatus)" [value]="'true'">
                                    <label for="true">Yes</label>
                                  </div>
                                  <div class="ml-3">
                                    <input type="radio" id="false" name="selectedStatus" [(ngModel)]="selectedStatus" (change)="superVisaChange(selectedStatus)" [value]="'false'">
                                    <label for="false">No</label>
                                  </div>
                              </div>
                            <div class="clear10"></div>
                            <label class="regular fs-16 tooltip1">Effective Date <span class="red5">*</span>
                                <img src="./assets/images/iIconblue.svg">
                                <div class="tooltiptext1 regular fs-14">
                                <span class="whitespacenormal italic tooltiptext2">Means the date on which your coverage commences as set out in Section 5 - EFFECTIVE AND EXPIRY DATES OF INSURANCE.</span>
                                </div>
                            </label>
                            <!-- <input readonly class="form-control forminput bg-White Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [min]="minDate" [(ngModel)]="startDate" (ngModelChange)="callStartDateFunction($event)">
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time> -->
                            <div class="quote-datepicker">
                                <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="datepicker1" placeholder="ddmmmyyyy" [(ngModel)]="startDate" [min]="minDate"  [max]="maxDatestart" (dateChange)="callStartDateFunction($event)">
                                <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
                                <mat-datepicker #datepicker1></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <p class="fs-14 regular red" *ngIf="startDateFlag">‘Effective Date’ is required.</p>
                            <p class="fs-14 regular red" *ngIf="startDateFlagValid">‘Effective Date’ is not valid.</p>
                            <!-- <p class="italic fs-14">This is the date you leave on your covered trip</p> -->
                            <div class="clear20"></div>
                            <label class="regular fs-16">Number of Travel Days</label>
                            <input class="form-control forminput Tab" type="tel" maxlength="3" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="calculatedDays" (ngModelChange)="callCalculatedDaysFunction()">
                            <!-- <input class="form-control forminput Tab" placeholder="Number of Travel Days" type="tel" maxlength="3" [(ngModel)]="calculatedDays" (input)="callCalculatedDaysFunction()"> -->
                            <p class="fs-14 regular redstar" *ngIf="errorFlagNoDays">An ‘Effective Date’ is required before adding the ‘Number of Travel Days’.</p>
                            <p class="fs-14 regular redstar" *ngIf="errorNegative">Number of travel days cannot be negative.</p>
                            <p class="fs-14 regular redstar" *ngIf="exceedNoOfDays">The ‘Number of Travel Days’ exceeds the allowed number of days allowed for this plan.</p>
                            <p class="fs-14 regular redstar" *ngIf="exceedNoOfDays1">The ‘Number of Travel Days’ is less than the minimum number of days (14) allowed for this plan.</p>
                            
                           
                            <!-- <p class="italic fs-14">This is the date you return from your covered trip</p> -->
                            <div class="clear20"></div>
                            <label class="regular fs-16 tooltip1">Expiry Date <span class="red5">*</span>
                                <img src="./assets/images/iIconblue.svg">
                                <div class="tooltiptext1 regular fs-14">
                                <span class="whitespacenormal italic tooltiptext2">
                                    Means the date your coverage ends as set out in Section 5 - EFFECTIVE AND EXPIRY DATES OF INSURANCE.</span>
                                </div>
                            </label>
                            <!-- <input readonly class="form-control forminput bg-White Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [min]="minDate" [(ngModel)]="expiryDate" (ngModelChange)="callExpiryDateFunction($event)">
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time> -->
                            <div class="quote-datepicker">
                                <mat-form-field appearance="fill">
                                <input matInput [matDatepicker]="datepicker2" placeholder="ddmmmyyyy" [(ngModel)]="expiryDate" [min]="minDate" (dateChange)="callExpiryDateFunction($event)">
                                <mat-datepicker-toggle matSuffix [for]="datepicker2"></mat-datepicker-toggle>
                                <mat-datepicker #datepicker2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <p class="fs-14 regular red" *ngIf="expiryDateFlag">‘Expiry Date’ is required.</p>
                            <p class="fs-14 regular red" *ngIf="expiryDateFlagValid">‘Expiry Date’ is not valid.</p>
                            <!-- <div class="clear20"></div>
                            <label class="regular fs-16">Resident of<span class="red5">*</span></label>
                            <ng-select placeholder="Select">
                                <ng-option>Pune</ng-option>
                                <ng-option>Mumbai</ng-option>
                                <ng-option>Nashik</ng-option>
                            </ng-select> -->
                        </div>
                        <div class="col-lg-8 padIn-12  ">
                            <label for="" class="bold fs-18">INSURED INFORMATION</label>
                            <div class="clear"></div>
                            <label class="regular fs-16">Number of Insureds <span class="red5">*</span></label>
                            <div>
                                <button type="button" class="decBTN" (click)="minusNumberOfInsured()"><i
                                        class="fa fa-minus"></i></button>
                                <input type="text" class="incdecTxt" [(ngModel)]="insuredCount">
                                <button type="button" class="incBTN" (click)="incNumberOfInsured()"><i
                                        class="fa fa-plus"></i></button>
                            </div>
                            <div class="clear30"></div>
                            <div class="horizontal"></div>
                            <div class="clear30"></div>
                            <div *ngFor="let item of travellerInfo; let i=index">
                                <label for="" class="bold fs-18">INSURED #{{i+1}}
                                    <u class="red5 pl-3 cp" *ngIf="showRemove" (click)="minusNumberOfInsuredShort(i)">Remove</u>
                                </label>
                                <ng-container>
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-4 padIn-12 padInR-12">
                                                <label class="regular fs-16 tooltip1">Date of Birth (DOB) <span class="red5">*</span>
                                                    <img src="./assets/images/iIconblue.svg">
                            <div class="tooltiptext1 regular fs-14">
                                <span class="whitespacenormal italic tooltiptext2">DOB is the insured's date of birth.</span>
                            </div>   
                                                </label>
                                                <!-- <input readonly class="form-control forminput bg-White Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [max]="minDateDOB" [min]="minDateDOB120" [(ngModel)]="item.dateOfBirth" (ngModelChange)="callDateOfBirth($event)">
                                                <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time> -->
                                                <div class="quote-datepicker">
                                                    <mat-form-field appearance="fill">
                                                    <input matInput [matDatepicker]="datepicker3" placeholder="ddmmmyyyy" [(ngModel)]="item.dateOfBirth" [max]="minDateDOB" [min]="minDateDOB120" (dateChange)="callDateOfBirth($event)">
                                                    <mat-datepicker-toggle matSuffix [for]="datepicker3"></mat-datepicker-toggle>
                                                    <mat-datepicker #datepicker3></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                                <p class="fs-14 regular red" *ngIf="item.dobFlag">'Date of Birth’ is not valid.</p>
                                                <p class="fs-14 regular red" *ngIf="item.ageErrorCross">The ‘Date of Birth’ entered falls outside the age eligible for coverage under this plan.</p>
                                                <p class="fs-14 regular red" *ngIf="item.ageErrorCrossFlag">The ‘Date of Birth’ entered falls outside the age eligible for coverage under this plan.</p>
                                                <p class="fs-14 regular red" *ngIf="item.ageErrorCrossFlag1">The insured must be at least 15 days old.</p>
                                            </div>
                                            <div class="col-lg-2 padIn-12 padInR-12">
                                                <label class="regular fs-16 tooltip1">Age <span class="red5">*</span>
                                                    <img src="./assets/images/iIconblue.svg">
                                                    <div class="tooltiptext1 regular fs-14">
                                                    <span class="whitespacenormal italic tooltiptext2">Means your age on the date you apply for coverage.</span>
                                                    </div>
                                                </label>
                                                <input type="tel"  class="dayinput" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" [(ngModel)]="item.age" (change)="onChangeAge(i)">
                                            </div>
                                            <div class="col-lg-4 padIn-12 padInR-12">
                                                <label class="regular fs-16">Arrival in Canada <span class="red5">*</span></label>
                                             
                                                <div class="quote-datepicker">
                                                    <mat-form-field appearance="fill">
                                                        <input matInput [matDatepicker]="datepicker4" placeholder="ddmmmyyyy" [(ngModel)]="item.arrivalDateOfCanada" [max]="minDateArrival" (dateChange)="callArriveCanadaDate($event,i)">
                                                        <mat-datepicker-toggle matSuffix [for]="datepicker4"></mat-datepicker-toggle>
                                                        <mat-datepicker #datepicker4></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                                <p class="fs-14 regular red" *ngIf="item.ArrivalDateFlagValid">'Arrival' date is not valid.</p>
                                                <p class="fs-14 regular red" *ngIf="item.arrivalDateCanadaFlag">'Arrival' date is required.</p>
                                            </div>
                                            <div class="col-lg-2 padIn-12 padInR-12">
                                                <label class="regular fs-16 tooltip1 nowrap">Wait Period
                                                    <img src="./assets/images/iIconblue.svg">
                                                    <div class="tooltiptextwaitPeriod regular fs-14">
                                                        <span class="whitespacenormal italic tooltiptext2">If your policy was purchased after your departure from your home country a waiting period may apply. During a waiting period, you are ineligible for benefits.</span>
                                                    </div> 
                                                </label>
                                                <input class="waitperiodBOX"   [(ngModel)]="item.waitPeroid" readonly>

                                                
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <div class="clear10"></div>
                            </div>
                            <div class="row">
                                <!-- <div class="col-lg-6">
                                    <div class="ml-2">
                                        <label class="container">
                                        <input type="checkbox" class="form-check-input">
                                        <span class="checkmark"></span>
                                        </label>
                                        <span class="fs-14 bold ml30">Family Rate</span>
                                    </div>
                                    
                                </div> -->
                                <!-- <div class="col-lg-6">
                                    <div class="ml-2">
                                        
                                        <label class="container">
                                            <input type="checkbox" class="form-check-input" [checked]="familyRate"  [(ngModel)]="familyRate" (change)="onClickfamilyRate($event);callFamilyRate()">
                                            <span class="checkmark"></span>
                                            </label>
                                            <span class="fs-14 bold ml30">Family Rate</span>
                                        <p class="dateSubtxt1 redstar" *ngIf="familyRateFlag">
                                            Family plan requires at least one adult (age greater than 20) and one child (age less than or equal to 20)
                                        </p>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div *ngIf="showIntStudPlanPlanOption">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                            <div class="whitebox br-6 p-2 mr-2">
                                <div class="border-bottom p-2">
                                    <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                                </div>
                                <div class="p-2">
                                    <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                                    <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
                                 
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                                    <p class="purple bold fs-16">{{daysToshow}}</p>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                                    <label class="purple bold fs-16">{{resdentShowShow}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insureds:</label><br>
                                    <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                                    <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                                        <img src="./assets/images/iIconblue.svg">
                                    <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal  tooltiptext2">DOB is the insured's date of birth.</span>
                                    </div>
                                    </label>
                                    <div class="purple bold fs-16 " *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                                   
                                    
                                    
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                                    <p *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - (Age: {{item.age}})</p>
                                    <label [hidden]="showSaveQuotesValVTC=='true'" class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                                    <div [hidden]="showSaveQuotesValVTC=='true'" *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - ({{item.waitPeroid}})</div>
                                    <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                                    <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                                    <div class="horizontal mt-1"></div>
                                    <ul id="popupbullets" class="ulbulletclass">
                                        <!-- <li class="desclist">
                                            Quoted rate is valid today only.
                                        </li> -->
                                        <li class="desclist ">Click on ‘View Details’ under a plan name for detailed information, including the policy wording.</li>
                                        <li class="desclist ">If you have a pre-existing medical condition, some conditions to the terms of your coverage may apply. Please read the policy for details.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8">
                            <div class="p-2">
                                <label class="bold fs-16">PLAN OPTIONS</label>
                            </div>
                            <div class="border-bottom ml-2 mr-2"></div>
                            <div class="clear10"></div>
                            <div class="row" *ngIf="visitorsToCanadaChecked1=='true'" [hidden]="planNameToShow!=='Essential Plan'">
                                <label class="lightgray2 regular fs-16 mr-2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 ml-4">Visitors To Canada Essential Plan</label>
                                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 ml-4">
                                    <!-- <label class="lightgray2 regular fs-16 ml-2 ">Deductibe Option</label> -->
                                    <label class="lightgray2 regular fs-16 ">Deductible Option
                                        <img src="./assets/images/iIconblue.svg" matTooltip="deductable amout for this plan is $0. To change the duductiable and reduce the premimium choose from the list"  > 
                                    </label>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                                    
                                    <ng-select  placeholder="Select" [(ngModel)]="vtcEssentialPlan" (change)="selectdeductOptionForEssentialPlan()">                            
                                        <!-- (click)="validateLanguage(selectedQuestionlanguages1)" -->
                                        <ng-option  *ngFor="let item of deductOption" [value]="item.value">{{item.label}}</ng-option>
            
                                    </ng-select>
                                </div>
                            </div>
                            <div class="clear10"></div>
                            <div class="row"  *ngIf="visitorsToCanadaChecked2=='true'" [hidden]="planNameToShow=='Essential Plan'">
                                <label class="lightgray2 regular fs-16 mr-2 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 ml-4">Visitors To Canada Premier Plan  </label>
                                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 ml-4">
                                    <label class="lightgray2 regular fs-16 ">Deductible Option
                                        <img src="./assets/images/iIconblue.svg" matTooltip="deductable amout for this plan is $0. To change the duductiable and reduce the premimium choose from the list"  > 
                                    </label>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                                    <ng-select  placeholder="Select" [(ngModel)]="vtcPemierPlan" (change)="selectdeductOptionForPrimierPlan()" >                            
                                        <!-- (click)="validateLanguage(selectedQuestionlanguages1)" -->
                                        <ng-option  *ngFor="let item of deductOption" [value]="item.value">{{item.label}}</ng-option>
            
                                    </ng-select>
                                
                                </div>
                            </div>
                            <div class="clear10"></div>
                            <div class="horizontal2"></div>
                            <label class="bold fs-16">QUOTE PLAN LIMIT TYPE</label>
                            <div class="row mt-4">
                                <div class="d-flex" *ngFor="let item of planLimitType">
                                    <!-- <mat-checkbox appearance="fill" class="ml-4" [checked]="item.checked"
                                     (change)="selectPlanLimit($event.checked,item)">
                                     
                                    </mat-checkbox> -->
                                    <label class="container paddingwidth">
                                        <input type="checkbox" class="form-check-input" [checked]="item.checked"   (change)="selectPlanLimit($event,item)">
                                        <span class="checkmark"></span>
                                        </label>
                                        <span class="fs-14  mr-3 mt-1 mb-2">{{item.name}}</span>
                                </div>
                            </div>
                            <div class="border-bottom ml-2 mr-2"></div>
                            <div class="p-2">
                                <label class="bold fs-16">INSURANCE PACKAGES</label>
                            </div>
                            <div class="p-2">
                                <div id="purchasePlan" class="">
                                <table id="planInfo" class="w100">
                                    <thead class="nowrap">
                                        <tr>
                                            <th>Plan</th>
                                            <!-- <th>Other Info</th> -->
                                            <th>Total Amount</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <tr  *ngFor="let item of planQuoteResponsesToShow">
                                            <td>
                                                <label [hidden]="showSaveQuotesValVTC=='true'" class="fs-14 bold" (click)="planNameClick(item.planName,item.policyPremium);viewPolicyDetailsPopup=!viewPolicyDetailsPopup">{{item.name}}</label><br>
                                                <label [hidden]="showSaveQuotesValVTC=='false'"class="fs-14 bold" (click)="planNameClick(item.planName,item.policyPremium);viewPolicyDetailsPopup=!viewPolicyDetailsPopup">{{item.planName}}</label><br>
                                                <span class="viewPolicy cp" (click)="planNameClick(item.planName,item.policyPremium);viewPolicyDetailsPopup=!viewPolicyDetailsPopup">View Details</span>
                                            </td>
                                           
                                            <td>
                                                <label [hidden]="showSaveQuotesValVTC=='true'" class="amtTXT bold">$ {{item.prem}}</label>
                                                <label [hidden]="showSaveQuotesValVTC=='false'" class="amtTXT bold">{{item.premiumDispl}}</label>
                                                <!-- <button class="btnPurchase " (click)="purchasePlan(item)">Purchase</button> -->
                                            </td>
                                            <td>
                                                <!-- <label class="amtTXT bold">$ {{item.prem}}</label> -->
                                                <button class="btnPurchase " (click)="purchasePolicy(item)">Purchase</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showQuestionnaire">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                            <div class="whitebox br-6 p-2 mr-2">
                                <div class="border-bottom p-2">
                                    <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                                </div>
                                <div class="p-2">
                                    <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                                    <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                                    <p class="purple bold fs-16">{{daysToshow}}</p>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                                    <label class="purple bold fs-16">{{resdentShowShow}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insureds:</label><br>
                                    <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                                    <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                                        <img src="./assets/images/iIconblue.svg">
                                    <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal  tooltiptext2">DOB is the insured's date of birth.</span>
                                    </div>
                                    </label>
                                    <div class="purple bold fs-16 " *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                                   
                                    
                                    
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                                    <div *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">
                                        <p *ngIf="item.notEligibleFlag==false">
                                        Insured {{i+1}} - (Age: {{item.age}})
                                    </p>
                                    <p *ngIf="item.notEligibleFlag==true">
                                        Insured {{i+1}} - (Age: {{item.age}}) [Not Eligible]
                                    </p>
                                </div>
                                    <!-- <div *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">
                                        <p *ngIf="item.notEligibleFlag==true">
                                        Insured {{i+1}} (Age: {{item.age}}) [Not Eligible]
                                    </p></div> -->
                                    <!-- <p *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} (Age: {{item.age}})</p> -->
                                    <label [hidden]="showSaveQuotesValVTC=='true'" class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                                    <div [hidden]="showSaveQuotesValVTC=='true'" *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - ({{item.waitPeroid}})</div>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Name:</label><br>
                                    <label class="purple bold fs-16 cp underline" (click)="viewPolicyDetailsPopup=!viewPolicyDetailsPopup;openTabs(1)">{{selectedPlanName}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Info:</label><br>
                                    <label class="purple bold fs-16 cp underline" (click)="onSelectedBoxFile(0)">View Policy</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Total Amount:</label><br>
                                    <label class="purple bold fs-16">{{selectedPlanPrice}}</label><br>
                                    <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                                    <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                                    <!-- <div class="horizontal "></div>
                                    <ul id="popupbullets" class="ulbulletclass">
                                         <li class="desclist">
                                            Quoted rate is valid today only.
                                        </li>
                                        <li class="desclist ">Click on ‘View Details’ under a plan name for detailed information, including the policy wording.</li>
                                        <li class="desclist ">If you have a pre-existing medical condition, some conditions to the terms of your coverage may apply. Please read the policy for details.</li>
                                    </ul> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12 pl-2">
                            <div class="questionnairemsgbox">
                                <p class="qnaTXT1">To determine if the insured(s) is/are eligible to purchase the International Student Travel Insurance Policy, all of the following questions must be answered by the insured(s). If the insured(s) is/are not sure how to answer a question, they must check with their doctor.</p>
                                    <p class="qnaTXT1">If the insured(s) has/have a pre-existing medical condition, additional terms and conditions may apply. Please read the policy for complete details. As of the date you apply for this coverage and the effective date, please answer the following questions:</p>
                            </div>
                            <div class="clear10"></div>
                            <div *ngIf="showQuestionnaireQue">
                                <!-- <mat-progress-bar mode="determinate" value="40"></mat-progress-bar> -->
                                <div class="clear10"></div>
                                <div *ngFor="let item of qestionInfoArray;let i=index">
                                    <div *ngIf="i== questionNumbers">
                                        <div class="clear30"></div>
                                        <mat-progress-bar mode="determinate" [value]="matProgressValue">
                                        </mat-progress-bar>
                                        <div class="clear30"></div>
                                        <div class="new-Whitebox">
                                            <label *ngIf="item.questionPoints.length == 1" class="question1">{{questionNumbers+1}}.
                                                <label *ngFor="let ele of item.questionArray" class="remove-bottom-margin">
                                                    <label class="remove-bottom-margin" *ngIf="!ele.isHover">{{ele.word}}</label>
                                                    <label class="remove-bottom-margin bluetxt" matTooltip="{{ele.tooltip}}" *ngIf="ele.isHover">{{ele.word}}</label>&nbsp;
                                                </label>
                                            </label>
                                            <label *ngIf="item.questionPoints.length > 1">
                                                <div *ngFor="let points of item.questionPoints let k=index">
                                                    <label *ngIf="k==0" class="question1">
                                                        {{questionNumbers+1}}. {{points}}
                                                    </label>
                                                    <label class="quepoints" *ngIf="k!=0">{{points}}</label>
                                                </div>
                                            </label>
                                            <div *ngIf="!item.haveSubQuetions">
                                                <div *ngFor="let data of travellerInformation;let j = index">
                                                    <p class="applicantTXT">Applicant {{j+1}} (Age: {{data.age}})</p>
                                                    <!-- <mat-button-toggle-group name="fontStyle" aria-label="Font Style">   [checked]="data.isClickedOnYes[i].isClickedOnYes"  [checked]="data.isClickedOnNo[i].isClickedOnNo"-->
                                                        <button type="submit" value="Yes"
                                                        [ngClass]="data.isClickedOnYes[i].isClickedOnYes==true?'addbtn':'yesBTN'"
                                                        (click)="YesbuttonClick(item,data,j+1,i)" class="w101 regular mr-2">Yes</button>
                                                        <button  type="submit" value="No"  [ngClass]="data.isClickedOnNo[i].isClickedOnNo==true?'addbtn':'noBTN'" (click)="NobuttonClick(item,data,i)" class="w101 regular">No
                                                        </button>
                                                        <!-- <p class="desclist" *ngIf="data.notEligibleFlag==true">
                                                            [Based on your response to this question, we cannot offer you coverage.]
                                                        </p>
                                                        <p class="desclist" *ngIf="data.notEligibleFlag==true && j!=i">
                                                            [Not Eligible]
                                                        </p> -->
                                                    <!-- </mat-button-toggle-group> -->
                                                    <div class="clear20"></div>
                                                </div>
                                            </div>
                                            <div *ngIf="item.haveSubQuetions" >
                                                <div *ngFor="let data of travellerInformation;let j = index">
                                                    <p class="applicantTXT">Applicant {{j+1}} (Age: {{data.age}})</p>
                                                    <div class="sub-question-container">
                                                        <div *ngFor="let subQue of data.subQuetions; let k=index" >
                                                            <div class="sub-question-box">
                                                                <label class="sub-question col-lg-6">{{subQue.subQuestion}}</label>
                                                                <div class="col-lg-4" >
                                                                    <!-- <mat-button-toggle-group name="fontStyle" aria-label="Font Style"> [checked]="subQue.isClickOnNo"  [checked]="subQue.isClickOnYes"-->
                                                                        <button  value="Yes"  [ngClass]="subQue.isClickOnYes==true?'addbtn':'yesBTN'"
                                                                            (click)="SubQueYesbutton(k,data,j,item,i)" class="w101 regular mr-2"
                                                                            >Yes</button>
                                                                        <button  value="No"  [ngClass]="subQue.isClickOnNo==true?'addbtn':'noBTN'"
                                                                            (click)="SubQueNobutton(k,data,j,item,i)" class="w101 regular">No
                                                                        </button>
                                                                    <!-- </mat-button-toggle-group> -->
                                                                    <!-- <p class="desclist" *ngIf="data.notEligibleFlag==true">
                                                                        We cannot offer you coverage
                                                                    </p> -->
                                                                </div>
                                                            </div>
                                                            <div *ngIf="k != item.subQuetions.length-1" class="border-down"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clear30"></div>
                                        <div class="row justify-end">
                                            <button mat-raised-button class="prevBTN" [disabled]="checkYesNoPrev"
                                                (click)="prevQuestion()">Previous</button>
                                            <button mat-raised-button class="nextBTN" [disabled]="checkYesNo"
                                                (click)="updateQuestion()">Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="notEligible" *ngIf="showErrorForQuestion">
                                <div class="new-Whitebox">
                                    <label for="" class="question1">Not Eligible</label>
                                    <p class="desclist">
                                        We cannot offer you coverage based on your answer to the following question:
                                    </p>
                                    <div class="greynewBox" *ngIf="!NotEligibleForSubQue">
                                        <p class="applicantAge">Applicant {{applicantIndex}} (Age:
                                            {{ageShowNotEligible}}) :<span
                                                class="regular16 pl-2">{{questionToshowNoteligible}}
                                                activities?</span></p>
                                        <p class="applicantAge">Your answer :<span
                                                class="redstar regularyes pl-2">Yes</span></p>

                                    </div>
                                    <div class="greynewBox" *ngIf="NotEligibleForSubQue">
                                        <p class="applicantAge">Applicant {{applicantIndex}} (Age:{{ageShowNotEligible}}):
                                            <span class="regular16-red pl-2">Answered YES to 2 or more conditions in question 7.</span>
                                        </p>
                                    </div>
                                    <div class="clear30"></div>
                                    <p class="finalpara">If you think you may have answered a question incorrectly,
                                        click the "Previous" button below to return to the previous screen.</p>
                                </div>
                                <div class="clear30"></div>
                                <div class="row justify-end">
                                    <button class="prevBTN" (click)="prevQuestionNotEligible()">Previous</button>
                                    <button class="nextBTN" *ngIf="showNextquesbtn==true" (click)="closeEligiblePop()">Next</button>
                                </div>
                            </div>

                            <div *ngIf="showDeclarationQuestionnaire">
                                <div class="questionWhitebox">
                                    <label for="" class="bold fs-18">Declaration</label>
                                        <!-- <P class="fs-16 regular">Please communicate the following declaration to the applicant(s):</P> -->
                                        <P class="declareTXT">Please communicate the following declaration to the insured(s):
                                        </P>
                                        <div class="clear30"></div>
                                        <div class="innergreyBox">
                                            <p class="desclist">
                                                You declare that the information given is accurate. If you were unsure
                                                about the medical information needed for a question you have checked
                                                with your doctor.
                                            </p>
                                            <p class="desclist">
                                                You understand that if you have provided incorrect information Old
                                                Republic Insurance Company of Canada will void the policy and cancel all
                                                coverage.
                                            </p>
                                            <p class="desclist">
                                                You also understand that if your health changes before Your Start Date
                                                you must contact your broker to update your eligibility.
                                            </p>
                                        </div>
                                <div class="clear20"></div>
                                <div>
                                    <div class="" *ngFor="let data of travellerInformation;let j = index">
                                        <label class="container" *ngIf="data.notEligibleFlag != true">
                                        <input type="checkbox" class="form-check-input" [checked]="data.checkDeclaration" (click)="onClickDeclaration($event,data,j)">
                                        <span class="checkmark"></span>
                                        </label>
                                        <span class="fs-14 bold ml30" *ngIf="data.notEligibleFlag != true">Insured {{j+1}} (Age: {{data.age}})</span>
                                        <p class="fs-14 regular red" *ngIf="data.checkDeclaration==false && data.notEligibleFlag != true ">To continue, read the ‘Declaration’ above. If you agree, check the box beside the insured(s).</p>
                                    </div>
                                    <!-- <p class="fs-14 regular red" *ngIf="declarationErrorFlag">Please check the declaration to continue</p> -->
                                    
                                </div>
                                </div>
                                    <div class="clear10"></div>
                                    <div class="row text-right">
                                        <button  class="prevBTN" (click)="prevQuestion8()">Previous</button>
                                        <button  class="nextBTN" (click)="updateQuestion8();step2ApiCall()">Proceed</button>
                                        <!-- onClickQuestionnaireProceed -->
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showContactInfo">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                            <div class="whitebox br-6 p-2 mr-2">
                                <div class="border-bottom p-2">
                                    <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                                </div>
                                <div class="p-2">
                                    <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                                    <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                                    <p class="purple bold fs-16">{{daysToshow}}</p>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                                    <label class="purple bold fs-16">{{resdentShowShow}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insureds:</label><br>
                                    <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                                    <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                                        <img src="./assets/images/iIconblue.svg">
                                    <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal italic tooltiptext2">DOB is the insured's date of birth.</span>
                                    </div>
                                    </label>
                                    <div class="purple bold fs-16 " *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                                   
                                    
                                    
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                                    <p *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - (Age: {{item.age}})</p>
                                    <label [hidden]="showSaveQuotesValVTC=='true'" class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                                    <div [hidden]="showSaveQuotesValVTC=='true'" *ngFor="let item of travellerInformation;let i=index" class="purple bold fs-16 ">Insured {{i+1}} - ({{item.waitPeroid}})</div>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Name:</label><br>
                                    <label class="purple bold fs-16 cp underline" (click)="viewPolicyDetailsPopup=!viewPolicyDetailsPopup;openTabs(1)">{{selectedPlanName}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Info:</label><br>
                                    <label class="purple bold fs-16 cp underline"  (click)="onSelectedBoxFile(0)">View Policy</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Total Amount:</label><br>
                                    <label class="purple bold fs-16">{{selectedPlanPrice}}</label><br>
                                    <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                                    <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                                    <!-- <div class="horizontal "></div>
                                    <ul id="popupbullets" class="ulbulletclass">
                                       
                                        <li class="desclist ">Click on ‘View Details’ under a plan name for detailed information, including the policy wording.</li>
                                        <li class="desclist ">If you have a pre-existing medical condition, some conditions to the terms of your coverage may apply. Please read the policy for details.</li>
                                    </ul> -->
                                </div>
                            </div>
                        </div>
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12 pl-2">
                    <div *ngFor="let item of travellerInformation;let i=index">
                        <!-- <div *ngIf="item.notEligibleFlag != true"> -->
                    <div class="row">
                        <!-- <div class="mr-3"><img src="./assets/images/accounticon.svg"></div> -->
                        <div>
                            <label class="bold fs-18">Insured {{i+1}}</label><br>
                            <!-- <label class="bold red5 fs-18">(Age: 24)</label> -->
                        </div>        
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black">First Name<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name" [(ngModel)]="item.firstName" (input)="removeFirstNameError(i)">
                                <p class="fs-14 regular redstar" *ngIf="item.firstNameFlag">'First Name' is required.</p>

                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black">Last Name<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name"  [(ngModel)]="item.lastName" (input)="removeLastNameError(i)">
                                <p class="fs-14 regular redstar" *ngIf="item.lastNameFlag">'Last name' is required.</p>

                            </div>
                        </div>
                        <!-- <div *ngIf="i==0" class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black tooltip1">Institute<span class="redstar">*</span>
                                <img src="./assets/images/iIconblue.svg">
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">The 'Institute' is the name of the Canadian educational facility where you will be studying.</span>
                                </div></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Institute’s name"  [(ngModel)]="item.insitute" (input)="removeInstituteNameError(i)">
                                <p class="fs-14 regular redstar" *ngIf="item.InstituteFlag">'Institute' name is required.</p>

                            </div>
                        </div>
                        <div *ngIf="i==0" class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black">Home Country<span class="redstar">*</span></label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="item.homeCountry" (input)="removeCountryNameError(i)">
                                    <ng-option *ngFor="let item1 of countryListing" [value]="item1">{{item1}}</ng-option>
                                  
                                </ng-select>
                                <p class="fs-14 regular redstar" *ngIf="item.CountryFlag">‘Home Country’ is required.</p>

                            </div>
                        </div> -->
                    </div>
                    <div class="clear20"></div>
                    <!-- <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black tooltip1">Institute<span class="redstar">*</span>
                                <img src="./assets/images/iIconblue.svg">
                                <div class="tooltiptext1 regular fs-14">
                                    <span class="whitespacenormal italic tooltiptext2">The 'Institute' is the name of the Canadian educational facility where you will be studying.</span>
                                </div></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Enter the institute’s name"  [(ngModel)]="item.insitute" (input)="removeInstituteNameError(i)">
                                <p class="fs-14 regular redstar" *ngIf="item.InstituteFlag">'Institute' name is required.</p>

                            </div>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black">Home Country<span class="redstar">*</span></label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="item.homeCountry" (input)="removeCountryNameError(i)">
                                    <ng-option *ngFor="let item1 of countryListing" [value]="item1">{{item1}}</ng-option>
                                  
                                </ng-select>
                                <p class="fs-14 regular redstar" *ngIf="item.CountryFlag">‘Home Country’ is required.</p>

                            </div>
                        </div>
                    </div> -->
                    <!-- </div> -->
                    <div class="clear10"></div>
                </div>
                    
                    <div class="clear10"></div>
                    <div class="border-bottom"></div>
                    <div class="clear10"></div>
                    <label class="bold fs-18">Please enter the primary address where the insured will be staying while in Canada</label>
                    <div class="clear10"></div>
                    <!-- <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">First Name <span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name" [(ngModel)]="purchaserFirstName" (input)="onpurchaseFirstnameClick()">
                                <p class="fs-14 regular redstar" *ngIf="purchaserFirstNameFlag">'Purchaser First Name' is required.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Last Name <span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name" [(ngModel)]="purchaserLastName" (input)="onpurchaseLastnameClick()">
                                <p class="fs-14 regular redstar" *ngIf="purchaserLastNameFlag">'Purchaser Last Name' is required.</p>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div> -->
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Address 1</label>
                            <div>
                                <!-- <input  class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="address1"> -->
                                <input  class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="address1" (input)="callAddressApiCall()">
                                
                                <!-- <p class="fs-14 regular redstar" *ngIf="purchaserAddress1Flag">'Address' is required.</p> -->
                                <div class="searchResultBox" *ngIf="showAddressResults">
                                    <h6 class="close1 text-right mt-1 mr-1" (click)=" this.showAddressResults = !this.showAddressResults;">&times;</h6>
                                    <div class="borderbottom">
                                    </div>
                                    <div class="row borderbottom p-1" *ngFor="let item of getAddress">
                                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label class="fs-14 regular m-0 link cp" (click)="onClickSearchResult(item)">{{item.place_name}}</label><br>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Address 2</label>
                            <div>
                                <input class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="address2">
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">City</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="City" [(ngModel)]="City" (input)="onCityClick()">
                                <!-- <p class="fs-14 regular redstar" *ngIf="purchaseCityFlag">‘City’ is required.</p> -->
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Province</label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="Province" (change)="onProvinceClick()">
                                    <ng-option selected disabled value=undefined>Select</ng-option>
                                    <ng-option *ngFor="let item of provincesArray" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                                    <!-- <ng-option value="Non Resident of Canada">Non Resident of Canada
                                    </ng-option>             -->
                                </ng-select>
                            </div>
                            <!-- <p class="fs-14 regular redstar" *ngIf="purchaseProvinceFlag">'Province' is required.</p> -->
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Postal Code</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="PostalCode" (input)="onPostalCodeClick()" maxlength="7">
                                <!-- <p class="fs-14 regular redstar" *ngIf="purchasePostalCodeFlag">'Postal code' is required.</p> -->
                            </div>
                        </div>
                   
                    </div>
                    <!-- <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Phone 1<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type Here" [(ngModel)]="purchasePhone1" maxlength="15" (input)="onPhoneClick1()">
                                <p class="fs-14 regular redstar" *ngIf="purchasePhone1Flag">'Phone1' is required.</p>
                                <p class="fs-14 regular redstar" *ngIf="notValidPhoneNo">Phone Number is not valid.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Phone 2</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type Here" [(ngModel)]="purchasePhone2" maxlength="15" (input)="onPhoneClick2()">
                                <p class="fs-14 regular redstar" *ngIf="purchasePhone2Flag">'Phone2' is required.</p>
                                <p class="fs-14 regular redstar" *ngIf="notValidPhoneNo2">Phone Number is not valid.</p>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Email Address<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Email Address" [(ngModel)]="purchaseEmail"  (input)="onEmailClick();emailCheck();checkConfirmEmail()">
                                <p class="fs-14 regular redstar" *ngIf="purchaseEmailFlag">'Email Address' is required.</p>
                                <p class="fs-14 regular redstar" *ngIf="emailNotValid">Email is not valid.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Confirm Email Address<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Confirm Email Address" [(ngModel)]="purchaseEmailConfirm" (input)="checkConfirmEmail()">
                                <p class="fs-14 regular redstar" *ngIf="confirmEmailMatch">Email and Confirm Email Address does not match.</p>
                                <p class="fs-14 regular redstar"  *ngIf="purchaseConfirmEmailFlag">'Confirm Email Address' is required.</p>
                            </div>
                        </div>
                    </div>

                    <div class="clear10"></div>
                    <div class="border-bottom"></div>
                    <div class="clear10"></div>
                    <label class="bold fs-18">Optional Information</label>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Comments</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="comment" maxlength="64"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Beneficiary</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="If this field is left blank, the beneficiary will default to “Estate”." [(ngModel)]="beneficiary" maxlength="32"></textarea>
                            </div>
                        </div>
                    </div> -->
                    <div class="clear20"></div>
                    <div class="" >
                        <label class="container">
                        
                        <input [disabled]="showcheckbox==false"  type="checkbox" class="form-check-input" [checked]="purchaserAddressSame"   (change)="onClickAddressSameCheckbox($event)">
                        <span class="checkmark"  [ngClass]="purchaserAddressSame ? ' input:checked~.checkmark' : 'checkmark'"></span>
                        </label>
                        <span class="fs-14 regular lightgray2 ml30" >Check this box if this address is the same address as the person purchasing this policy.</span>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Message</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="agentNote"></textarea>
                            </div>
                        </div>
                    </div> -->
                
                    </div>
                </div>
                </div>    
            </div>
            <div *ngIf="showPayment">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                            <div class="whitebox br-6 p-2 mr-2">
                                <div class="border-bottom p-2">
                                    <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                                </div>
                                <div class="p-2">
                                    <label class="lightgray2 regular fs-16 lblmb0">Travel Dates:</label><br>
                                    <label class="purple bold fs-16">{{startDateShow | date:'ddMMMyyyy'}} - {{expiryDateShow | date:'ddMMMyyyy'}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Travel Days:</label>
                                    <p class="purple bold fs-16">{{daysToshow}}</p>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Purchaser's Province of Residence:</label><br>
                                    <label class="purple bold fs-16">{{resdentShowShow}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Number of Insured’s:</label><br>
                                    <label class="purple bold fs-16">{{travellerInformation.length}}</label><br>
                                    <label class="lightgray2 regular fs-16 tooltip1 mt-2 lblmb0">DOB:
                                        <img src="./assets/images/iIconblue.svg">
                                    <div class="tooltiptext1 regular fs-14">
                                        <span class="whitespacenormal italic tooltiptext2">DOB is the insured's date of birth.</span>
                                    </div>
                                    </label>
                                    <div class="purple bold fs-16 " *ngFor="let item of travelllerDetailsPersonArray;let i=index">{{item.firstName}} {{item.lastName}} - ({{item.dateOfBirth | date:'dd MMM yyyy'}})</div>
                                   
                                    
                                    
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Insured Information:</label>
                                    <p *ngFor="let item of travelllerDetailsPersonArray;let i=index" class="purple bold fs-16 ">{{item.firstName}} {{item.lastName}} - (Age: {{item.age}})</p>
                                    <label [hidden]="showSaveQuotesValVTC=='true'" class="lightgray2 regular fs-16 mt-2 lblmb0">Wait Period:</label>
                                    <div [hidden]="showSaveQuotesValVTC=='true'" *ngFor="let item of travelllerDetailsPersonArray;let i=index" class="purple bold fs-16 ">{{item.firstName}} {{item.lastName}} - ({{item.waitPeroid}})</div>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Name:</label><br>
                                    <label class="purple bold fs-16 cp underline" (click)="viewPolicyDetailsPopup=!viewPolicyDetailsPopup;openTabs(1)">{{selectedPlanName}}</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Plan Info:</label><br>
                                    <label class="purple bold fs-16 cp underline"  (click)="onSelectedBoxFile(0)">View Policy</label><br>
                                    <label class="lightgray2 regular fs-16 mt-2 lblmb0">Total Amount:</label><br>
                                    <label class="purple bold fs-16">{{selectedPlanPrice}}</label><br>
                                    <!-- <label class="lightgray2 regular fs-16">Arrival Date in Canada</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.arrivalDateOfCanada | date:'ddMMMyyyy'}}</div><br> -->
                                    <!-- <label class="lightgray2 regular fs-16">Waiting Period</label><br>
                                    <div class="purple bold fs-16" *ngFor="let item of travellerInformation">{{item.waitPeroid}}</div><br> -->
                                    <div class="horizontal "></div>
                                    <ul id="popupbullets" class="ulbulletclass">
                                        <!-- <li class="desclist">
                                            Quoted rate is valid today only.
                                        </li> -->
                                        <li class="desclist ">Click 'Pay Now' to purchase this policy.</li>
                                        <li class="desclist ">You will receive a policy Confirmation of Coverage (COC) by email.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12 pl-2">
                        <div class="clear10"></div>
                    <label class="bold fs-18">PURCHASER INFORMATION</label>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">First Name <span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name" [(ngModel)]="purchaserFirstName" (input)="onpurchaseFirstnameClick()">
                                <p class="fs-14 regular redstar" *ngIf="purchaserFirstNameFlag">'Purchaser First Name' is required.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Last Name <span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name" [(ngModel)]="purchaserLastName" (input)="onpurchaseLastnameClick()">
                                <p class="fs-14 regular redstar" *ngIf="purchaserLastNameFlag">'Purchaser Last Name' is required.</p>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row" *ngIf="!NonResidentSelected">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Address 1<span class="redstar">*</span></label>
                            <div>
                                <!-- <input  class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchaserAddress1"> -->
                                <input  class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchaserAddress1" (input)="callAddressApiCall1()">
                                
                                <p class="fs-14 regular redstar" *ngIf="purchaserAddress1Flag">'Address' is required.</p>
                                <div class="searchResultBox" *ngIf="showAddressResults1">
                                    <h6 class="close1 text-right mt-1 mr-1" (click)=" this.showAddressResults1 = !this.showAddressResults1;">&times;</h6>
                                    <div class="borderbottom">
                                    </div>
                                    <div class="row borderbottom p-1" *ngFor="let item of getAddress1">
                                      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <label class="fs-14 regular m-0 link cp" (click)="onClickSearchResult1(item)">{{item.place_name}}</label><br>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Address 2</label>
                            <div>
                                <input class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchaserAddress2">
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12" *ngIf="!NonResidentSelected">
                            <label class="regular fs-14 txt-black">City<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="City" [(ngModel)]="purchaseCity" (input)="onCityClick()">
                                <p class="fs-14 regular redstar" *ngIf="purchaseCityFlag">‘City’ is required.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Province<span class="redstar">*</span></label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="purchaseProvince" (change)="onProvinceClick1()">
                                    <ng-option selected disabled value=undefined>Select</ng-option>
                                    <ng-option *ngFor="let item of provincesArray" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                                    <!-- <ng-option value="Non Resident of Canada">Non Resident of Canada
                                    </ng-option>             -->
                                </ng-select>
                            </div>
                            <p class="fs-14 regular redstar" *ngIf="purchaseProvinceFlag">'Province' is required.</p>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row" *ngIf="!NonResidentSelected">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Postal Code<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="purchasePostalCode" (input)="onPostalCodeClick()" maxlength="7">
                                <p class="fs-14 regular redstar" *ngIf="purchasePostalCodeFlag">'Postal code' is required.</p>
                            </div>
                        </div>
                   
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Phone 1<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type Here" [(ngModel)]="purchasePhone1" maxlength="15" (input)="onPhoneClick1()">
                                <p class="fs-14 regular redstar" *ngIf="purchasePhone1Flag">'Phone1' is required.</p>
                                <p class="fs-14 regular redstar" *ngIf="notValidPhoneNo">Phone Number is not valid.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Phone 2</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type Here" [(ngModel)]="purchasePhone2" maxlength="15" (input)="onPhoneClick2()">
                                <p class="fs-14 regular redstar" *ngIf="purchasePhone2Flag">'Phone2' is required.</p>
                                <p class="fs-14 regular redstar" *ngIf="notValidPhoneNo2">Phone Number is not valid.</p>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Email Address<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Email Address" [(ngModel)]="purchaseEmail"  (input)="onEmailClick();emailCheck();checkConfirmEmail()">
                                <p class="fs-14 regular redstar" *ngIf="purchaseEmailFlag">'Email Address' is required.</p>
                                <p class="fs-14 regular redstar" *ngIf="emailNotValid">Email is not valid.</p>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Confirm Email Address<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Confirm Email Address" [(ngModel)]="purchaseEmailConfirm" (input)="checkConfirmEmail()">
                                <p class="fs-14 regular redstar" *ngIf="confirmEmailMatch">Email and Confirm Email Address does not match.</p>
                                <p class="fs-14 regular redstar"  *ngIf="purchaseConfirmEmailFlag">'Confirm Email Address' is required.</p>
                            </div>
                        </div>
                    </div>

                    <div class="clear10"></div>
                    <div class="border-bottom"></div>
                    <div class="clear10"></div>
                    <label class="bold fs-18">Optional Information</label>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Comments</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="comment" maxlength="64"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Beneficiary</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="If this field is left blank, the beneficiary will default to “Estate”." [(ngModel)]="beneficiary" maxlength="32"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <div class="border-bottom"></div>
                    <div class="clear10"></div>
                    <label class="bold fs-18">PAYMENT INFORMATION</label>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                            <label class="regular fs-14 txt-black">Total Amount<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="selectedPlanPrice" disabled>
                            </div>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mr-15">
                            <label class="regular fs-14 txt-black">Card Number<span class="redstar">*</span>&nbsp;<span class="fs-14 regular txt-black">{{cardType}}</span></label>
                            <div>
                                <input  type="text"  class="form-control forminput1 Tab col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12"  placeholder="Type here"  [value]="showMaskedCard ? displayCardNumber : cardNoToSend"  (focus)="showMaskedCard = false"  (blur)="onBlur()"  (input)="onInput($event);cardNoClick();ValidateCreditCardNumber()"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"  maxlength="16"  autocomplete="off"/>
                                <p class="fs-14 regular redstar" *ngIf="cardNoValid">'Card Number' is not valid.</p>
                                <p class="fs-14 regular redstar" *ngIf="cardError">'Card Number' is not valid.</p>
                            </div>
                        </div>
                        <!-- <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                            <label class="regular fs-14 txt-black">CVV<span class="redstar">*</span></label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8" placeholder="CVV" [(ngModel)]="cvvToSend" (input)="cvvClick()" maxlength="3">
                                <p class="fs-14 regular redstar" *ngIf="cvvValid">'CVV' is not valid.</p>
                            </div>
                        </div> -->
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black">Expiry Month<span class="redstar">*</span></label>
                            <div>
                                <ng-select class="col-sm-11 col-md-11 col-lg-11 col-xl-11 col-11" placeholder="Select" [(ngModel)]="expDate1ToSend" (change)="expiryDateClick()">
                                    <ng-option disabled value="undefined" selected>Select</ng-option>
                                    <ng-option value="01">01-Jan</ng-option>
                                    <ng-option value="02">02-Feb</ng-option>
                                    <ng-option value="03">03-Mar</ng-option>
                                    <ng-option value="04">04-Apr</ng-option>
                                    <ng-option value="05">05-May</ng-option>
                                    <ng-option value="06">06-Jun</ng-option>
                                    <ng-option value="07">07-Jul</ng-option>
                                    <ng-option value="08">08-Aug</ng-option>
                                    <ng-option value="09">09-Sep</ng-option>
                                    <ng-option value="10">10-Oct</ng-option>
                                    <ng-option value="11">11-Nov</ng-option>
                                    <ng-option value="12">12-Dec</ng-option>
                                </ng-select>
                            </div>
                            <p class="fs-14 regular redstar" *ngIf="expirydateValid">'Expiry Date' is not valid.</p>
                        </div>
                        <div  class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                            <label class="regular fs-14 txt-black">Expiry Year<span class="redstar">*</span></label>
                            <div>
                                <ng-select class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="Select" [(ngModel)]="expDateYearToSend" (change)="expiryYearClick()">
                                    
                                    <ng-option value="25" selected>2025</ng-option>
                                    <ng-option value="26">2026</ng-option>
                                    <ng-option value="27">2027</ng-option>
                                    <ng-option value="28">2028</ng-option>
                                    <ng-option value="29">2029</ng-option>
                                    <ng-option value="30">2030</ng-option>
                                    <ng-option value="31">2031</ng-option>
                                    <ng-option value="32">2032</ng-option>
                                    <ng-option value="33">2033</ng-option>
                                    <ng-option value="34">2034</ng-option>
                                </ng-select> 
                            </div>
                            <p class="fs-14 regular redstar" *ngIf="expiryyrValid">'Expiry year' is not valid.</p>
                        </div>
                    </div>
                    </div>
                </div>
                    <!-- <div class="row"> -->
                        <!-- <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-1"> -->
                            <!-- <div class="row">
                                <div class="payMentBox col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                                    <div class="border-bottom p-2">
                                        <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Payment</span>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                            <label class="regular fs-14 txt-black">Payment Amount</label>
                                            <div>
                                                <label class="bold fs-16 green">$17.22</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                            <label class="regular fs-14 txt-black">Premium</label>
                                            <div>
                                                <label class="bold fs-16 purple">$15.22</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                            <label class="regular fs-14 txt-black">Tax</label>
                                            <div>
                                                <label class="bold fs-16 purple">$2</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="row">
                                <div class="payMentBox col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                                    <div class="border-bottom p-2">
                                        <span class="red5 bold fs-16">Plan : {{selectedPlanName}}</span>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Premium:</label>
                                            <div>
                                                <label class="bold fs-16 purple">{{selectedPlanPrice}}</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Insureds:</label>
                                            <div>
                                                <label class="bold fs-16 purple">{{travellerInformation.length}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Number of Travel Days:</label>
                                            <div>
                                                <label class="bold fs-16 purple">{{daysToshow}}</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Arrival Date in Canada</label>
                                            <div>
                                                <label class="bold fs-16 purple" *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - ({{item.arrivalDateOfCanada | date:'dd MMM yyyy'}})</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Age</label>
                                            <div>
                                                <label class="bold fs-16 purple" *ngFor="let item of travellerInformation;let i=index">Insured {{i+1}} - (Age: {{item.age}})</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                    
                                    </div>
                                </div>
                            </div> -->
                        <!-- </div> -->
                        <!-- <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-1">
                            <div class="row">
                                <div class="payMentBox borderRed col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                                    <div class="border-bottom p-2">
                                        <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Payments</span>
                                    </div>
                                    <div class="clear10"></div>
                                    <label class="regular fs-14 txt-black">Payment Schedule<span class="red5">*</span></label>
                                    <div class="clear10"></div>
                                    <label class="bold fs-14 red5">Payment</label>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Total Amount<span class="redstar">*</span></label>
                                            <div>
                                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="selectedPlanPrice" disabled>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Card Number<span class="redstar">*</span>&nbsp;<span class="fs-14 regular redstar">{{cardType}}</span></label>
                                            <div>
                                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here" [(ngModel)]="cardNoToSend" (input)="cardNoClick();ValidateCreditCardNumber()" maxlength="16">
                                                <p class="fs-14 regular redstar" *ngIf="cardNoValid">'Card Number' is not valid.</p>
                                                <p class="fs-14 regular redstar" *ngIf="cardError">'Card Number' is not valid.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">CVV<span class="redstar">*</span></label>
                                            <div>
                                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="CVV" [(ngModel)]="cvvToSend" (input)="cvvClick()" maxlength="3">
                                                <p class="fs-14 regular redstar" *ngIf="cvvValid">'CVV' is not valid.</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Expiry Month<span class="redstar">*</span></label>
                                            <div>
                                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="expDate1ToSend" (click)="expiryDateClick()">
                                                    <ng-option disabled value="undefined" selected>Select</ng-option>
                                                    <ng-option value="01">January</ng-option>
                                                    <ng-option value="02">February</ng-option>
                                                    <ng-option value="03">March</ng-option>
                                                    <ng-option value="04">April</ng-option>
                                                    <ng-option value="05">May</ng-option>
                                                    <ng-option value="06">June</ng-option>
                                                    <ng-option value="07">July</ng-option>
                                                    <ng-option value="08">August</ng-option>
                                                    <ng-option value="09">September</ng-option>
                                                    <ng-option value="10">October</ng-option>
                                                    <ng-option value="11">November</ng-option>
                                                    <ng-option value="12">December</ng-option>
                                                </ng-select>
                                            </div>
                                            <p class="fs-14 regular redstar" *ngIf="expirydateValid">'Expiry Date' is not valid.</p>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Expiry Year<span class="redstar">*</span></label>
                                            <div>
                                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="expDateYearToSend" (click)="expiryYearClick()">
                                                    <ng-option value="23" selected >2023</ng-option>
                                                    <ng-option value="24">2024</ng-option>
                                                    <ng-option value="25">2025</ng-option>
                                                    <ng-option value="26">2026</ng-option>
                                                    <ng-option value="27">2027</ng-option>
                                                    <ng-option value="28">2028</ng-option>
                                                </ng-select> 
                                            </div>
                                            <p class="fs-14 regular redstar" *ngIf="expiryyrValid">'Expiry year' is not valid.</p>
                                        </div>
                                        
                                    </div>
                                    <div class="clear20"></div>
                                    <button *ngIf="checkPayInFull" type="button" class="fs-14 bold splitPaymentbtn">Split Payment</button>
                                    <label *ngIf="checkPayInMonthly" class="fs-16 semi-bold link cp" (click)="onClickMonthlyPayment()"><u>Monthly Payment Schedule</u></label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 padInright">
                                    <label for="" class="lbl1">Card Number<span class="redstar">*</span>&nbsp;<span class="fs-14 regular redstar">{{cardType}}</span></label>
                                    <div class="row">
                                        <div class="col-lg-9">
                                    <input type="text"  class="tlInfo "  [(ngModel)]="cardNoToSend" (input)="cardNoClick();ValidateCreditCardNumber()" maxlength="16">
                                    <p class="fs-14 regular redstar" *ngIf="cardNoValid">Card Number is Not Valid</p>
                                    <p class="fs-14 regular redstar" *ngIf="cardError">Card is not valid</p>
                                        </div>
                                        <div class="col-lg-3">
                                            <input type="text" placeholder="CVV" class="tlInfo " [(ngModel)]="cvvToSend" (input)="cvvClick()">
                                    <p class="fs-14 regular redstar" *ngIf="cvvValid">Cvv</p>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 padInleft">
                                    <label for="" class="lbl1">Expiry Date <span class="redstar">*</span></label>
                                    <div class="row">
                                        <div class="col-lg-8 ">
                                            <select name="" id="cardMonth" [(ngModel)]="expDate1ToSend" (click)="expiryDateClick()">
                                            <option value="undefined" selected>select</option>
                                            <option value="01">January</option>
                                            <option value="02">February</option>
                                            <option value="03">March</option>
                                            <option value="04">April</option>
                                            <option value="05">May</option>
                                            <option value="06">June</option>
                                            <option value="07">July</option>
                                            <option value="08">August</option>
                                            <option value="09">september</option>
                                            <option value="10">October</option>
                                            <option value="11">November</option>
                                            <option value="12">December</option>
                                        </select>
                                        </div>
                                        <p class="fs-14 regular redstar" *ngIf="expirydateValid">Expiry month</p>
                                        <div class="col-lg-4 padInleft" [(ngModel)]="expDateYearToSend" (click)="expiryYearClick()">
                                            <select name="" id="cardYear">
                                            <option value="23" selected>2023</option>
                                            <option value="24">2024</option>
                                            <option value="25">2025</option>
                                            <option value="26">2026</option>
                                            <option value="27">2027</option>
                                            <option value="28">2028</option>
                                        </select>
                                        </div>
                                        <p class="fs-14 regular redstar" *ngIf="expiryyrValid">Expiry year</p>
                                    </div>

                                </div>
                            </div>
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>
            <div *ngIf="showPaymentsDetails">
                <div class="conclass">
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Policy Basics:</label>
                        <label class="bold fs-16 green m-0">&nbsp;&nbsp;Active</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Agent</label>
                                <div class="bold fs-14 purple">tst - test test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Departure</label>
                                <div class="bold fs-14 purple">Vancouver</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Destination</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Ref Num</label>
                                <div class="bold fs-14 purple">234567</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Beneficiary</label>
                                <div class="bold fs-14 purple">Belgium</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                                <div class="bold fs-14 purple">$0.00</div>
                            </div>
                        </div>
                        <div class="clear10"></div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Premium</label>
                                <div class="bold fs-14 purple">$27.72 ($27.72 + $0.00 tax) 8.32c</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Policy Dates</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Effective</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Expiry</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Application</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Contact Information</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Name</label>
                                <div class="bold fs-14 purple">tst - test test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Address</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Email</label>
                                <div class="bold fs-14 purple">xyz@xyz.com</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Day Phone</label>
                                <div class="bold fs-14 purple">(N/A)</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Night Phone</label>
                                <div class="bold fs-14 purple">(N/A)</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Language</label>
                                <div class="bold fs-14 purple">English</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Plan:</label>
                        <label class="bold fs-16 red5 m-0">&nbsp;&nbsp;International Student Plan</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured</label>
                                <div class="bold fs-14 purple">Dummy</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured Amt.</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Payments</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Date</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Type</label>
                                <div class="bold fs-14 purple">Cheque</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                                <div class="bold fs-14 purple">$11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                                <div class="bold fs-14 purple">$00</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Card Number</label>
                                <div class="bold fs-14 purple">04152022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Exp(mm/yy)</label>
                                <div class="bold fs-14 purple">04/22</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Other Info</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Fulfillment</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h100" *ngIf="showStudAccidentInsure">
            <div class="clear10"></div>
            <div class="" *ngIf="showStudAccidentInsureStep1">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-11 mycontent-right">
                            <label for="" class="bold fs-18">QUOTE DETAILS</label>
                            <div class="horizontal"></div>
                            <div class="clear10"></div>
                            <label class="regular fs-16">Effective Date<span class="red5">*</span> (mm/dd/yyyy)</label>
                            <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1">
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                            <div class="clear20"></div>
                            <label class="regular fs-16">Expiry Date<span class="red5">*</span> (mm/dd/yyyy)</label>
                            <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2">
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                            <div class="clear20"></div>
                            <label class="regular fs-16">Number of Insureds<span class="red5">*</span></label>
                            <div>
                                <button type="button" class="decBTN" (click)="minusNumberOfInsured()"><i
                                        class="fa fa-minus"></i></button>
                                <input type="text" class="incdecTxt" [value]="numberOFInsured">
                                <button type="button" class="incBTN" (click)="incNumberOfInsured()"><i
                                        class="fa fa-plus"></i></button>
                            </div>
                            <div class="clear20"></div>
                            <label class="regular fs-16">Resident of<span class="red5">*</span></label>
                            <ng-select placeholder="Select">
                                <ng-option>Pune</ng-option>
                                <ng-option>Mumbai</ng-option>
                                <ng-option>Nashik</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-11 padIn-12  ">
                            <label for="" class="bold fs-18">INSURED (S)</label>
                            <div class="clear"></div>
                            <!-- <label class="lbl1">Number of Insureds <span class="red5">*</span></label>
                            <div>
                                <button type="button" class="decBTN" (click)="minusNumberOfInsured()"><i
                                        class="fa fa-minus"></i></button>
                                <input type="text" class="incdecTxt" [value]="numberOFInsured">
                                <button type="button" class="incBTN" (click)="incNumberOfInsured()"><i
                                        class="fa fa-plus"></i></button>
                            </div> -->
                            <!-- <div class="clear30"></div> -->
                            <div class="horizontal"></div>
                            <!-- <div class="clear30"></div> -->
                            <div>
                                <label for="" class="bold fs-18">INSURED #1
                                    <u class="red5 pl-3 cp">Remove</u>
                                </label>
                                <ng-container>
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-5 padIn-12">
                                                <label class="regular fs-16">Date Of Birth <span class="red5">*</span>(mm/dd/yyyy)
                                                </label>
                                                <input class="form-control forminput Tab" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3">
                                                <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                                            </div>
                                            <div class="col-lg-5 padIn-12">
                                                <label class="regular fs-16">Age</label>
                                                <input type="text" value="25 Y" class="greenTxt" readonly>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showStudAccidentInsurePlanOption">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4 border-right">
                            <div class="whitebox br-6 p-2 mr-2">
                                <div class="border-bottom p-2">
                                    <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Quote Details</span>
                                </div>
                                <div class="p-2">
                                    <label class="lightgray2 regular fs-16">Insured Dates</label><br>
                                    <label class="purple bold fs-16">09 Feb 2022 - 28 Feb 2022 (20 Days)</label><br>
                                    <label class="lightgray2 regular fs-16">Resident of</label><br>
                                    <label class="purple bold fs-16">Ontario</label><br>
                                    <label class="lightgray2 regular fs-16">Insured(s)</label><br>
                                    <label class="purple bold fs-16">DOB: 08Feb2022</label><br>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-8">
                            <div class="p-2">
                                <label class="bold fs-16 mb-0">PLANS</label>
                            </div>
                            <div class="p-2">
                                <div class="tableheadFix">
                                <table id="planInfo" class="w100">
                                    <thead class="nowrap">
                                        <tr>
                                            <th>Plan</th>
                                            <th>Other Info</th>
                                            <th>Total Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <tr>
                                            <td>
                                                <label class="cp planTXT bold">International Student Smart Plan</label>
                                                <p class="viewPolicy regular cp">View Policy</p>
                                            </td>
                                            <td>
                                                <ul class="planList">
                                                    <li class="list1 regular">Multiple trips in a year</li>
                                                    <li class="list1 regular">Medical and Non - Medical Coverage</li>
                                                    <li class="list1 regular">Please see the policy for complete details of benefits, exclusions, limitations, terms and conditions.</li>
                                                </ul>
                                            </td>
                                            <td>
                                                <label class="amtTXT bold">$17.64</label>
                                                <button class="btnPurchase" (click)="onClickPurchaseStudAccidentInsure()">Purchase</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showContactInfoStudAccidentInsure">
                <div class="conclass">
                    <div class="row">
                        <div class="mr-3"><img src="./assets/images/accounticon.svg"></div>
                        <div>
                            <label class="bold fs-18">Insured #1</label><br>
                            <label class="bold red5 fs-18">(Age: 24)</label>
                        </div>        
                    </div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">First Name</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name">
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Last Name</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name">
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Language</label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Airline</label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Cruise Line</label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Tour Operator</label>
                            <div>
                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                    <ng-option>Dummy</ng-option>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <div class="border-bottom"></div>
                    <div class="clear10"></div>
                    <label class="bold fs-18">Parent / Guardian</label>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">First Name</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="First Name">
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Last Name</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Last Name">
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Address Line 1</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Address Line 2</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">City Postal Code</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="City Postal Code">
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Daytime / Evening Phone</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Daytime / Evening Phone">
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Email Address</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Email Address">
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Confirm Email Address</label>
                            <div>
                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Confirm Email Address">
                            </div>
                        </div>
                    </div>
                    <div class="clear10"></div>
                    <div class="border-bottom"></div>
                    <div class="clear10"></div>
                    <label class="bold fs-18">Optional Information</label>
                    <div class="clear10"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Comment</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Beneficiary</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                            <label class="regular fs-14 txt-black">Message</label>
                            <div>
                                <textarea rows="3" class="textarea col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here"></textarea>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
            <div *ngIf="showPaymentStudAccidentInsure">
                <div class="conclass">
                    <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-1">
                            <div class="row">
                                <div class="payMentBox col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                                    <div class="border-bottom p-2">
                                        <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Payment</span>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                            <label class="regular fs-14 txt-black">Payment Amount</label>
                                            <div>
                                                <label class="bold fs-16 green">$17.22</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                            <label class="regular fs-14 txt-black">Premium</label>
                                            <div>
                                                <label class="bold fs-16 purple">$15.22</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                                            <label class="regular fs-14 txt-black">Tax</label>
                                            <div>
                                                <label class="bold fs-16 purple">$2</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="payMentBox col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                                    <div class="border-bottom p-2">
                                        <span class="red5 bold fs-16">Plan : International Student Plan</span>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Total</label>
                                            <div>
                                                <label class="bold fs-16 purple">$17.22</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Insured</label>
                                            <div>
                                                <label class="bold fs-16 purple">1 (Age 26, DOB : 25/5/19966)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Insured Amt</label>
                                            <div>
                                                <label class="bold fs-16 purple">$25,000</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Arrival Date in Canada</label>
                                            <div>
                                                <label class="bold fs-16 purple">16Feb2022</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Days</label>
                                            <div>
                                                <label class="bold fs-16 purple">11 (16Feb2022 - 26F...</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Option</label>
                                            <div>
                                                <label class="bold fs-16 purple">Deductible Option...</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Option</label>
                                            <div>
                                                <label class="bold fs-16 purple">Deductible Option...</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-1">
                            <div class="row">
                                <div class="payMentBox borderRed col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                                    <div class="border-bottom p-2">
                                        <img class="mr-2" src="./assets/images/quoteDetails.svg"><span class="red5 bold fs-16">Payments</span>
                                    </div>
                                    <div class="clear10"></div>
                                    <label class="regular fs-14 txt-black">Payment Schedule<span class="red5">*</span></label>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <div (click)="onClickPayInFull()">
                                                <input type="radio" [checked]="checkPayInFull">
                                               <label>Pay In Full : $17.64</label>
                                            </div>                    
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <div (click)="onClickPayMonthaly()">
                                                <input type="radio" [checked]="checkPayInMonthly">
                                                <label>&nbsp;Monthly : $18.64</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <label class="bold fs-14 red5">Payment: 1</label>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Total Amount</label>
                                            <div>
                                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Payment Type</label>
                                            <div>
                                                <ng-select class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select">
                                                    <ng-option>Credit Card</ng-option>
                                                    <ng-option>Net Banking</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear10"></div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Card Number</label>
                                            <div>
                                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                            <label class="regular fs-14 txt-black">Expiry (mm/yy)</label>
                                            <div>
                                                <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Type here">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clear20"></div>
                                    <button *ngIf="checkPayInFull" type="button" class="fs-14 bold splitPaymentbtn">Split Payment</button>
                                    <label *ngIf="checkPayInMonthly" class="fs-16 semi-bold link cp" (click)="onClickMonthlyPayment()"><u>Monthly Payment Schedule</u></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showPaymentsDetailsStudAccidentInsure">
                <div class="conclass">
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Policy Basics:</label>
                        <label class="bold fs-16 green m-0">&nbsp;&nbsp;Active</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Agent</label>
                                <div class="bold fs-14 purple">tst - test test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Departure</label>
                                <div class="bold fs-14 purple">Vancouver</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Destination</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Ref Num</label>
                                <div class="bold fs-14 purple">234567</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Beneficiary</label>
                                <div class="bold fs-14 purple">Belgium</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                                <div class="bold fs-14 purple">$0.00</div>
                            </div>
                        </div>
                        <div class="clear10"></div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Premium</label>
                                <div class="bold fs-14 purple">$27.72 ($27.72 + $0.00 tax) 8.32c</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Policy Dates</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Effective</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Expiry</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Application</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Contact Information</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Name</label>
                                <div class="bold fs-14 purple">tst - test test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Address</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Email</label>
                                <div class="bold fs-14 purple">xyz@xyz.com</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Day Phone</label>
                                <div class="bold fs-14 purple">(N/A)</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Night Phone</label>
                                <div class="bold fs-14 purple">(N/A)</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Language</label>
                                <div class="bold fs-14 purple">English</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Plan:</label>
                        <label class="bold fs-16 red5 m-0">&nbsp;&nbsp;Student Accident Insurance</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured</label>
                                <div class="bold fs-14 purple">Dummy</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured Amt.</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Payments</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Date</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Type</label>
                                <div class="bold fs-14 purple">Cheque</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                                <div class="bold fs-14 purple">$11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                                <div class="bold fs-14 purple">$00</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Card Number</label>
                                <div class="bold fs-14 purple">04152022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Exp(mm/yy)</label>
                                <div class="bold fs-14 purple">04/22</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Other Info</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Fulfillment</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h100" *ngIf="showSendSaveQuoteEmail">
            <div class="conclass">
                <div class="clear20"></div>
                <!-- <div [innerHTML]="savedEmailTemplate"></div> -->
                 <div class="regular fs-14">
                    Thank you for your interest in Travelance {{savedQuoteEmailPlanName}}.
                </div>
                <div class="clear10"></div>
                <div class="regular fs-14">
                    Per your request, you are receiving this email containing a quote for travel insurance.
                </div>
                <div class="clear10"></div>
                <div class="regular fs-14">
                    This quote is based on the information below. The policy wording is below for your review. If you wish to purchase this plan or if you have any questions please contact:
                </div>
                <div class="clear10"></div>
                <p class="regular fs-14">Travelance Tech<br>555-123-4567<br><a href="mailto:oristest@orican.com">OrisTest@orican.com</a></p>
                <div class="clear10"></div>
                <p class="semi-bold fs-16">Quote Details</p>
                <div class="clear10"></div>
                <div class="greyBox">
                    <table id="quoteEmail" class="regular fs-14 verticalAlign">
                        <thead>
                            <tr>
                                <th class="w240"></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Travel Dates:</td>
                                <td>{{startDate | date: 'ddMMMyyyy'}} - {{expiryDate | date: 'ddMMMyyyy'}} ({{calculatedDays}})</td>
                            </tr>
                            <tr>
                                <td>Resident Of:</td>
                                <td>{{selectedQuestionprovince1}}</td>
                            </tr>
                            <tr>
                                <td class="verticalAlign">Insured(s):</td>
                                <td>
                                    <div *ngFor="let item of travellerInformation; let i=index">
                                        <label>DOB: {{item.dateOfBirth | date: 'ddMMMyyyy'}},&nbsp;</label>
                                        <label>Wait Period: {{item.waitPeroid}}</label>
                                        <label *ngIf="item.firstName">,&nbsp;{{item.firstName}} {{item.lastName}}</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="clear10"></div>
                <p class="semi-bold fs-16">Plans</p>
                <div class="clear10"></div>
                <p class="regular fs-14 lightblue">The premiums below are cumulative for all insureds.</p>
                <div class="clear10"></div>
                <div class="greyBox">
                <table id="quoteEmail" class="regular fs-14">
                    <thead>
                        <tr>
                            <th class="w85">Plan</th>
                            <th class="w15 text-center">Premium</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="selectPlanDetails.length==0">
                        <tr *ngFor="let item of planQuoteResponses">
                            <td>
                                {{item.name}}<br>
                                <ul class="planList1">
                                    <li class="list1 regular"><div [innerHTML]="item.desc"></div></li>
                                </ul>
                                    <span class="viewPolicy regular cp" (click)="planNameClick(item.name,item.totprembefore);viewPolicyDetailsPopup=!viewPolicyDetailsPopup">View Details</span>
                            </td>
                            <td class="text-center"><a>{{item.totprembefore}}</a></td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="selectPlanDetails.length!=0">
                        <tr *ngFor="let item of selectPlanDetails">
                            <td>
                                {{item.name}}<br>
                                <ul class="planList1">
                                    <li class="list1 regular"><div [innerHTML]="item.desc"></div></li>
                                </ul>
                                <span class="viewPolicy regular cp" (click)="planNameClick(item.name,item.totprembefore);viewPolicyDetailsPopup=!viewPolicyDetailsPopup">View Details</span>
                            </td>
                            <td class="text-center"><a>{{item.totprembefore}}</a></td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <div class="clear20"></div>
                <div class="border-bottom"></div>
                <div class="clear20"></div>
                <p class="semi-bold fs-16">Insured(s)</p>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                        <p class="semi-bold fs-16">Insured</p>
                    </div>
                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                        <p class="semi-bold fs-16">First Name</p>
                    </div>
                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                        <p class="semi-bold fs-16">Last Name</p>
                    </div>
                </div>
                <div class="clear10"></div>
                <div class="row mb-2" *ngFor="let item of travellerInformation; let i=index">
                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                        <p class="semi-bold fs-16 link">(Age: {{item.age}})</p>
                    </div>
                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                        <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" [(ngModel)]="item.firstName" placeholder="First Name">
                    </div>
                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                        <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" [(ngModel)]="item.lastName" placeholder="Last Name">
                    </div>
                </div>
                <div class="clear20"></div>
                <p class="semi-bold fs-16">Actions</p>
                <div class="clear10"></div>
                <div class="pinkBox">
                    <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                            <p class="semi-bold fs-16">Email quote to</p>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                            <input type="text" class="form-control forminput1 Tab col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Email" [(ngModel)]="sendEmailofSavedPolicy" (input)="sendemailCheck()">
                            <!-- <p class="fs-14 regular redstar" *ngIf="showEmailError">Email is required.</p> -->
                            <p class="fs-14 regular redstar" *ngIf="sendemailNotValid">Email is not valid.</p>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                            <button *ngIf="saveQuoteStep1Active" type="submit" class="addbtn bold" (click)="sendEmailOnstep1()">Send</button>
                            <button *ngIf="saveQuoteStep2Active" type="submit" class="addbtn bold" (click)="sendEmailOnstep2()">Send</button>
                            <button *ngIf="saveQuoteStep3Active" type="submit" class="addbtn bold" (click)="sendEmailOnstep3()">Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="row">
                <div  class="footerBalck" *ngIf="showChooseQuote">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <!-- <label class="bold fs-18 m-0 txtwhite">9 Plans Selected</label> -->
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="ContinueandNextbtn bold" (click)="onClickSelectPlanContinue()">Next</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showIntStudPlanStep1">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg" (click)="onClickCancel()">
                        <!-- <button type="submit" class="saveQuotebtn mr-2 ml-1 bold" *ngIf="errorFlagNoDays==true || errorNegative==true || exceedNoOfDays==true || exceedNoOfDays1==true || ageErrorCross==true || startDateFlagValid==true || ArrivalDateFlagValid==true" ><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <!-- <button type="submit" class="saveQuotebtn mr-2 ml-1 bold" *ngIf="errorFlagNoDays==false && errorNegative==false && exceedNoOfDays==false &&  exceedNoOfDays1==false &&  ageErrorCross==false && startDateFlagValid==false && ArrivalDateFlagValid==false" (click)="openQuotePopUp();"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gobackToChooseQuote()">Back</button>
                       
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" *ngIf="errorFlagNoDays==true || errorNegative==true || exceedNoOfDays==true || exceedNoOfDays1==true || ageErrorCross==true || startDateFlagValid==true || ArrivalDateFlagValid==true" (click)="onClickToShowPlanInfo1()">Next</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" *ngIf="errorFlagNoDays==false && errorNegative==false && exceedNoOfDays==false &&  exceedNoOfDays1==false &&  ageErrorCross==false && startDateFlagValid==false  && ArrivalDateFlagValid==false"(click)="onClickToShowPlanInfo()">Next</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showIntStudPlanPlanOption">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg" (click)="onClickCancel()">
                        <!-- <button type="submit" class="saveQuotebtn ml-1 mr-2 bold" (click)="openSaveQuotepopUp1()"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn bold mr35" (click)="gotBackToIntStudPlan()">Back</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showQuestionnaire">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg" (click)="onClickCancel()">
                        <!-- <button type="submit" class="saveQuotebtn ml-1 mr-2 bold" (click)="openSaveQuotepopUp1()"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn bold mr35" (click)="gotBackToIntStudPlanOption()">Back</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showContactInfo">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg" (click)="onClickCancel()">
                        <!-- <button type="submit" class="saveQuotebtn ml-1 mr-2 bold" (click)="openQuotePopUp2()"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gotBackToQuestionnaire()">Back</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickContactInfoNext()">Next</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showPayment">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg" (click)="onClickCancel()">
                        <!-- <button type="submit" class="saveQuotebtn ml-1 mr-2 bold" (click)="openQuotePopUp2()"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gotBackToContactInfo()">Back</button>
                        <!-- <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickPaymentNext()">Pay Now</button> -->
                        <button type="submit" class="ContinueandNextbtn ml-1 bold"  *ngIf="purchaserLastNameFlag==true || purchaserFirstNameFlag==true || purchaseProvinceFlag==true || purchasePhone1Flag==true || purchaseEmailFlag==true || purchaseConfirmEmailFlag==true || cardNoValid==true || cvvValid==true || expirydateValid==true || expiryyrValid==true" >Pay Now</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" *ngIf="purchaserLastNameFlag==false && purchaserFirstNameFlag==false && purchaseProvinceFlag==false && purchasePhone1Flag==false && purchaseEmailFlag==false && purchaseConfirmEmailFlag==false && cardNoValid==false && cvvValid==false && expirydateValid==false && expiryyrValid==false"(click)="paymentCallVTC()">Pay Now</button>

                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showPaymentsDetails">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg">
                        <!-- <button type="submit" class="saveQuotebtn ml-1 mr-2 bold"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button> -->
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gotBackToPayment()">Back</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickFinalizePayment()">Finalize Payment</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showStudAccidentInsureStep1">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg">
                        <button type="submit" class="saveQuotebtn ml-1 mr-2 bold"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button>
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gobackToChooseQuoteFromSAI()">Back</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickStudAccidentInsureStep1()">Next</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showStudAccidentInsurePlanOption">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg">
                        <button type="submit" class="saveQuotebtn ml-1 mr-2 bold"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button>
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn bold mr35" (click)="gobackToSAIStep1()">Back</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showContactInfoStudAccidentInsure">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg">
                        <button type="submit" class="saveQuotebtn ml-1 bold"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gobackToSAIPlanOption()">Back</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickContactInfoNextStudAccidentInsure()">Next</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showPaymentStudAccidentInsure">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg">
                        <button type="submit" class="saveQuotebtn ml-1 mr-2 bold"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button>
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gotBackToContactInfoSAI()">Back</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickPaymentNextStudAccidentInsure()">Next</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showPaymentsDetailsStudAccidentInsure">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <img class="mr-2 cp" src="./assets/images/refresh.svg">
                        <button type="submit" class="saveQuotebtn ml-1 mr-2 bold"><img src="./assets/images/saveQuote.svg">&nbsp;Save Quote</button>
                        <label class="viewPolicy cp regular ml-1"  (click)="openDialog2()">Privacy Statement</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr-2 bold" (click)="gotBackToPaymentSAI()">Back</button>
                        <button type="submit" class="ContinueandNextbtn ml-1 bold" (click)="onClickFinalizePayment()">Finalize Payment</button>
                    </div>
                </div>
                <div  class="footerBalck" *ngIf="showSendSaveQuoteEmail">
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                        <!-- <label class="bold fs-18 m-0 txtwhite">9 Plans Selected</label> -->
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6 text-right">
                        <button type="submit" class="backbtn mr35 bold" (click)="gobackFromSaveQuoteEmail()">Back</button>
                    </div>
                </div>
            </div>
    </div>
</div>
<div id="showarrivalDateInCanadaPopup" class="modal modal-dialog-centered" [style.display]="showarrivalDateInCanadaPopup ? 'flex' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">Is the plan being purchased in continuation of an existing Canadian Visitors to Canada policy with no gap in coverage?</span>
            <!-- <h6 class="close text-right" (click)="showarrivalDateInCanadaPopup=!showarrivalDateInCanadaPopup">&times;</h6> -->
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                    <!-- <label class="regular fs-14 txt-black">Select</label> -->
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                        <select  class="form-control forminput1 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" placeholder="Select" [(ngModel)]="selectedQuestionAns1" (change)="onClickQuestion1(selectedQuestionAns1)">
                            <option disabled selected value=undefined>Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div>
                <!-- <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                    <label class="regular fs-14 txt-black">Province</label>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                        <ng-select placeholder="Select">                            
                            <ng-option>1</ng-option>
                            <ng-option>2</ng-option>
                        </ng-select>
                    </div>
                 </div>
                 <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                    <label class="regular fs-14 txt-black">Language</label>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                        <ng-select placeholder="Select">
                            <ng-option>1</ng-option>
                            <ng-option>2</ng-option>
                        </ng-select>
                    </div>
                 </div> -->
            </div>
            <div class="clear20"></div>
            <div class="row" *ngIf="innerPop">
                <label class="fs-16 text46 semi-bold">Was the current Visitors to Canada policy purchased from Travelance?</label>
                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                    <label class="regular fs-14 txt-black">Select</label>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                        <ng-select [(ngModel)]="selectedQuestionAns2" (change)="onClickQuestion2(selectedQuestionAns2)">
                            <ng-option disabled selected value=undefined>Select</ng-option>
                            <ng-option value="Yes">Yes</ng-option>
                            <ng-option value="No">No</ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="clear20"></div>
            <div class="text-right mr-5">
                <button type="button" *ngIf="showOkButton" class="fs-14 bold okbtnred" (click)="modalCloseQuestion()">OK</button>
            </div>
        </div>
    </div>
  </div>
  <div id="finalizePaymentPopupp" class="modal" [style.display]="finalizePaymentPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header text-center">
            <div class="fs-16 green bold">Sucessful</div>
            <div class="clear10"></div>
            <div class="fs-16 text46 semi-bold">The policy number is: TA216750</div>
            <div class="clear10"></div>
            <div class="fs-16 link regular cp"><u>Back To Policy detail page</u></div>
            <!-- <h6 class="close text-right" (click)="finalizePaymentPopup=!finalizePaymentPopup">&times;</h6> -->
        </div>
        <div class="modal-body">
            <label class="fs-16 text46 regular">Share with</label><br>
            <div>
                <input type="text" class="form-control forminput1 Tab col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com">
            </div>
            <div class="clear20"></div>
            <div>
                <input type="text" class="form-control forminput1 Tab col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12" placeholder="example@gmail.com">
            </div>
            <div class="clear20"></div>
            <div class="text-right">
                <button type="button" class="fs-14 bold okbtngreen" (click)="sendfinalizePaymentEmail()">Send</button>
            </div>
        </div>
    </div>
    <div class="clear10"></div>
    <div class="modal-content">
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12">
                    <label class="fs-16 text46 bold">View / Print</label><br>
                    <label class="fs-16 text46 regular">Confirmation of coverage</label>
                </div>
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">
                    <button type="submit" class="printbtn bold">Print</button>
                </div>
            </div>
        </div>
    </div>
  </div>
  <div id="showResidentLanguagePopup" class="modal modal-dialog-centered" [style.display]="showResidentLanguagePopup ? 'flex' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <label class=" tooltip1 fs-16 text46 semi-bold " style="padding-left: 22px;">At the time of purchase, is the purchaser residing in Canada?<span class="red5">*</span><img  src="./assets/images/iIconblue.svg">
            <div class="tooltiptext1 regular fs-14">
                <!-- <span class="whitespacenormal italic tooltiptext2">‘Resident Of’ is the province where the purchaser lives. The ‘purchaser’ is the person who is paying for the policy.  If the person who is paying for the policy does not live in Canada, please select "Non-Resident of Canada".</span> -->
                <span class="whitespacenormal italic tooltiptext2">‘Resident Of’ is the province where the purchaser lives. The ‘purchaser’ is the person who is paying for the policy. If the person who is paying for the policy does not live in Canada, select 'No'.</span>
            </div> 
        </label>  
            <h6 class="close text-right" (click)="onCloseRefresh()">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="row">
               
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 " style="padding-left: 22px;">
                <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" id="Select1">
                    <ng-select placeholder="Select" [(ngModel)]="selectedNonResident" (change)="changeNonResident(selectedNonResident)">
                        <ng-option selected disabled value=undefined>Select</ng-option>
                        <ng-option value="Yes">Yes</ng-option>
                        <ng-option value="No">No</ng-option>
                    </ng-select>
                </div> 
                </div> 
               
        </div>
        <div  *ngIf="shownew==false" class="modal-header">
            <span class="fs-16 text46 semi-bold">Please select the purchaser’s province of residence.</span>
        </div>
        <div  *ngIf="shownew==true" class="modal-header">
            <span class="fs-16 text46 semi-bold">Please select the purchaser's country of residence.</span>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12"  *ngIf="shownew==false">
                    <!-- <label class="regular fs-14 txt-black">Resident of<span class="red5">*</span></label> -->
                    <label class="tooltip1 regular fs-14">Resident of <span class="red5">*</span><img *ngIf="shownew==false" src="./assets/images/iIconblue.svg">
                        <div class="tooltiptext1 regular fs-14">
                            <!-- <span class="whitespacenormal italic tooltiptext2">‘Resident Of’ is the province where the purchaser lives. The ‘purchaser’ is the person who is paying for the policy.  If the person who is paying for the policy does not live in Canada, please select "Non-Resident of Canada".</span> -->
                            <span class="whitespacenormal italic tooltiptext2">‘Resident Of’ is the province where the purchaser lives. The ‘purchaser’ is the person who is paying for the policy.</span>
                        </div>   
                        </label>                        
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" id="Select1">
                        <ng-select placeholder="Select" placeholder="Select" [(ngModel)]="selectedQuestionprovince1"  (click)="validateResident(selectedQuestionprovince1)">
                            <ng-option selected disabled value=undefined>Select</ng-option>
                            <ng-option *ngFor="let item of provincesArray1" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                            <!-- <ng-option *ngIf="hideQuotePurchase!=='true'" value="Non-Resident of Canada">Non-Resident of Canada</ng-option> -->
                        </ng-select>
                    </div> 
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" *ngIf="shownew==true">
                    <!-- <label class="regular fs-14 txt-black">Resident of<span class="red5">*</span></label> -->
                    <label class="tooltip1 regular fs-14">Purchaser’s Country of Residence <span class="red5">*</span>
                        
                        </label>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10" id="Select1">
                        <!-- <ng-select placeholder="Select" placeholder="Select" [(ngModel)]="NonResidentCountry"  (click)="validateResident1(NonResidentCountry)">
                            <ng-option selected disabled value=undefined>Select</ng-option>
                            <ng-option *ngFor="let item of provincesArray1" [value]="item.provinceName">{{item.provinceName}}</ng-option>
                             <ng-option value="Not residing in Canada">Non-Resident of Canada</ng-option>
                        </ng-select> -->
                        <div>
                            <ng-select placeholder="Select" placeholder="Select" [(ngModel)]="NonResidentCountry"  (click)="validateResident1(NonResidentCountry)">
                            <ng-option selected disabled value=undefined>Select</ng-option>
                            <ng-option *ngFor="let item1 of countryListing1" [value]="item1.displayName">{{item1.displayName}}</ng-option>
                            </ng-select>
                            <!-- <p class="fs-14 regular redstar" *ngIf="item.CountryFlag">'Country' is required.</p> -->

                        </div>
                    </div> 
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12" >
                    <label class="regular fs-14 txt-black">Language<span class="red5">*</span></label>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                        <ng-select  placeholder="Select" [(ngModel)]="selectedQuestionlanguages1" (click)="validateLanguage(selectedQuestionlanguages1)">                            
                            <ng-option selected disabled value=undefined>Select</ng-option>
                            <ng-option *ngFor="let item of languagesArray" [value]="item">{{item}}</ng-option>

                        </ng-select>
                    </div>
                 </div>
            </div>
            <div class="clear10"></div>
            <div class="whitespacenormal fs-12 red5 italic ">The purchaser is the person who is paying for the policy. For more info, click on the blue icon.</div>

            <div class="clear20"></div>
            <div class="text-right mr-5">
                <button type="button" class="fs-14 bold okbtnred" *ngIf="shownew==false"  [hidden]="!selectedQuestionlanguages1 || !selectedQuestionprovince1" (click)="onClickSelectLanguageResident()">OK</button>
                <button type="button" class="fs-14 bold okbtnred" *ngIf="shownew==true"  [hidden]="!selectedQuestionlanguages1 || !selectedQuestionprovince1 || !NonResidentCountry" (click)="onClickSelectLanguageResident()">OK</button>
            </div>
        </div>
    </div>
  </div>
  </div>
  <div id="PayInMonthlyPopup" class="modal" [style.display]="showPayInMonthlyPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">Monthly Payment Schedule</span>
            <h6 class="close text-right" (click)="showPayInMonthlyPopup=!showPayInMonthlyPopup">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="tableheadFix">
                <table id="tableheadFixMonthlyPay" class="w100">
                    <thead class="nowrap">
                        <tr>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Payment Date</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Status</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Premium</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Tax</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Billing Fee</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Admin Fee</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <span>Payment Ampunt</span>
                                    <!-- <div class="d-flex flex-column ml-4">
                                        <i class="fa fa-caret-up"></i>
                                        <i class="fa fa-caret-down"></i>
                                    </div> -->
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="">
                        <tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr>
                        <tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr><tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr><tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr><tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr><tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr><tr>
                            <td>Apr 30, 2022</td>
                            <td>Billed</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                            <td>$00</td>
                            <td>$332.90</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="clear20"></div>
            <div class="text-right">
                <button type="button" class="fs-16 bold closebtn" (click)="showPayInMonthlyPopup=!showPayInMonthlyPopup">Close</button>
            </div>
        </div>
    </div>
  </div>
  <div id="viewPolicyDetails" class="modal" [style.display]="viewPolicyDetailsPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">{{PopupPlanName}}</span>
            <h6 class="close text-right" (click)="viewPolicyDetailsPopup=!viewPolicyDetailsPopup">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                <ul id="viewPolicyDetails1" class="posfix">
                    <li class="{{tabs[0].active}}" (click)="openTabs(0)"><a class="active">Description & Summary</a></li>
                    <li class="{{tabs[1].active}}" (click)="openTabs(1)"><a>Eligibility</a></li>
                    <li class="{{tabs[2].active}}" (click)="openTabs(2)"><a>Exclusions</a></li>
                    <!-- <li class="{{tabs[3].active}}" (click)="openTabs(3)"><a>Policy Wording</a></li> -->
                </ul>
                <!-- <button *ngIf="tabs[3].active" type="submit" class="fs-12 text-right" (click)="downloadPolicyWording()">Download</button> -->
            </div>
            <div class="{{tabs[0].tabcontent}}" *ngIf="tabs[0].active">
                <div class="clear20"></div>
                <!-- <h1 class="descTxt mt-3">Description</h1> -->
                <!-- <p class="descPara">The International Student Travel Insurance Policy is an emergency medical insurance plan providing coverage for students, their spouses, and/or their dependents (refer to the ‘Eligibility’ tab). 
                </p> -->
                <div class="clear20"></div>
                <div class="pt-4">
                    <h1 class="descTxt">Description</h1>
                    <p class="descPara">
                        The Essential Plan has been specifically created for Visitors to Canada, immigrants, and Canadians returning 
                        to Canada who are without a Canadian government health plan. It provides protection for unexpected medical 
                        emergencies while in Canada and for side trips outside of Canada (Please see Policy for conditions, limitations
                        and exclusions). Its flexible coverage offers a 10 day free look period and access to an experienced staff of
                        multilingual assistance professionals to help with medical emergencies that may happen during the period of coverage.
                    </p>
                    <div class="clear20"></div>
                    <ul  id="popupbullets" class="ulbulletclass">
                        <li class="desclist">Plan Limits of $25,000, $50,000, $100,000 and $150,000 Emergency Medical Benefits available for individuals over 14 days old and under 70 years of age during the entire Period of Coverage</li>
                        <li class="desclist">Plan Limits of $25,000, $50,000 and $100,000 Emergency Medical Benefits available for individuals over 69 years of age and under 86 years of age during the entire Period of Coverage</li>
                        <li class="desclist">Plan Limits of $100,000 or more meet Super Visa Requirements</li>
                        <li class="desclist">Covers trips up to 558 days in duration</li>
                        <li class="desclist">Affordable Family Rates</li>
                    </ul>
                </div>
                <div>
                    <h1 class="descTxt mt-3">Benefit Summary</h1>
                    <div class="row">
                        <div class="col-lg-6">
                        <p class="smallTxt">Emergency Medical</p>
                        </div>
                        <div class="col-lg-6">
                            <label for="" class="smallTxt">Up to Plan Limit</label>
                        </div>
                    </div>
                    <ul  id="popupbullets" class="ulbulletclass">
                        <li class="desclist">Emergency Medical Expenses</li>
                        <li class="desclist">Emergency Return Home</li>
                        <li class="desclist">Emergency Dental (up to $2,000)</li>
                        <li class="desclist">Repatriation of Remains (up to $10,000)</li>
                        <li class="desclist">Cremation/Burial at Destination (up to $4,000)</li>
                    </ul>
                </div>
                <div class="horizontal2"></div>
                <div class="pt-4 pb-4">
                    <a class="policyTXT cp" (click)="goTotab1()">Click Here to view the policy for this plan</a>
                </div>
                <div class="horizontal2"></div>
                <h1 class="descTxt mt-3">Important Notices</h1>
                <ul  id="popupbullets" class="ulbulletclass">
                    <li class="desclist">Travel insurance is designed to cover losses arising from sudden and unforeseeable
                        circumstances. It is important that you read and understand the policy before you purchase as the
                        coverage is subject to certain limitations, conditions or exclusions.
                    </li>
                    <li class="desclist">Pre-existing condition exclusions may apply to medical conditions and/or symptoms 
                        that existed prior to a covered trip. Check to see how these apply to your trip and how they relate 
                        to your departure date, date of purchase or effective date.
                    </li>
                    <li class="desclist">The information you provide us in order to make a policy purchase must be complete 
                        and accurate otherwise your policy will be void and no benefit will be payable under this policy
                    </li>
                    <li class="desclist">The policy is secondary to all other sources of coverage. Any benefits payable under 
                        the policy are in excess of any other coverage you may have with any other insurance company or any 
                        other source of recovery.
                    </li>
                    <li class="desclist">In the event of an injury or sickness, prior medical history may be reviewed when a claim is reported.</li>
                    <li class="desclist">The policy provides travel assistance and you are required to notify the emergency 
                        assistance provider prior to treatment. The policy limits benefits should you not contact the 
                        assistance provider within the specified time period.
                    </li>
                    <li class="desclist">You may cancel the policy within 10 days of purchase for a full refund if you have 
                        not departed on your covered trip and there is no claim in process. For the emergency medical only plan,
                        you may cancel any time prior to departure and receive a full refund
                    </li>
                    <li class="desclistnew">If you have any questions, you can contact us at 1-855-566-8555</li>
                </ul>
                <div class="clear20"></div>
                <!-- <h1 class="descTxt semi-bold mt-3">Description</h1>
                <p class="descPara">The Premier Plan has been specifically created for Visitors to Canada, immigrants, and Canadians returning to Canada who are without a Canadian government health plan. It provides protection for unexpected medical emergencies while visiting
                    Canada and for side trips outside of Canada, as well as coverage for pre-existing conditions (Please see Policy for conditions, limitations and exclusions). Its flexible coverage offers a 10 day free look period and access to an experienced
                    staff of multilingual assistance professionals to help with medical emergencies that may happen during the period of coverage.
                </p>
                <ul id="popupbullets" class="ulbulletclass">
                    <li class="desclist">Plan Limits of $25,000, $50,000, $100,000 and $150,000 Emergency Medical Benefits and Accidental Death & Dismemberment available for individuals over 14 days old and under 70 years of age during the entire Period of Coverage</li>
                    <li class="desclist">Plan Limits of $25,000, $50,000 and $100,000 Emergency Medical Benefits and Accidental Death & Dismemberment available for individuals over 69 years of age and under 86 years of age during the entire period of Coverage</li>
                    <li class="desclist">Additional and Upgraded Benefits compared to the Essential Plan</li>
                    <li class="desclist">Plan Limits of $100,000 or more meet Super Visa Requirements</li>
                    <li class="desclist">Covers trips up to 558 days in duration</li>
                    <li class="desclist">Affordable Family Rates</li>
                </ul>
                <h1 class="descTxt semi-bold mt-3">Benefit Summary</h1>
                <div class="row">
                    <div class="col-lg-6">
                        <p class="smallTxt semi-bold">Emergency Medical</p>
                    </div>
                    <div class="col-lg-6">
                        <label for="" class="smallTxt semi-bold">Up to Plan Limit</label>
                    </div>
                </div>
                <ul type="disc" id="popupbullets" class="ulbulletclass">
                    <li class="desclist">Emergency Medical Expenses</li>
                    <li class="desclist">Emergency Return Home</li>
                    <li class="desclist">Emergency Dental (up to $4,000)</li>
                    <li class="desclist">Emergency Paramedical</li>
                    <li class="desclist">Visit to Bedside</li>
                    <li class="desclist">Repatriation of Remains (up to $16,000)</li>
                    <li class="desclist">Repatriation of Remains (up to $16,000)</li>
                    <li class="desclist">Cremation/Burial at Destination (up to $6,000)</li>
                    <li class="desclist">Return of Baggage and Personal Effects</li>

                </ul>
                <div class="row">
                    <div class="col-lg-6">
                        <p class="smallTxt semi-bold">Accidental Death and Dismemberment</p>
                    </div>
                    <div class="col-lg-6">
                        <label class="smallTxt semi-bold">Up to Plan Limit ($100,000 Maximum)</label>
                    </div>
                </div>
                <div class="clear20"></div>
                <div class="horizontal2"></div>
                <label class="policyTXT semi-bold cp">Click Here to view the policy for this plan</label>
                <div class="horizontal2"></div>
                <h1 class="descTxt semi-bold mt-3">Important Notices</h1>
                <ul id="popupbullets" class="ulbulletclass">
                    <li class="desclist">Travel insurance is designed to cover losses arising from sudden and unforeseeable circumstances. It is important that you read and understand the policy before you purchase as the coverage is subject to certain limitations, conditions
                        or exclusions.</li>
                    <li class="desclist">Pre-existing condition exclusions may apply to medical conditions and/or symptoms that existed prior to a covered trip. Check to see how these apply to your trip and how they relate to your departure date, date of purchase or effective
                        date.
                    </li>
                    <li class="desclist">The information you provide us in order to make a policy purchase must be complete and accurate otherwise your policy will be void and no benefit will be payable under this policy
                    </li>
                    <li class="desclist">The policy is secondary to all other sources of coverage. Any benefits payable under the policy are in excess of any other coverage you may have with any other insurance company or any other source of recovery.</li>
                    <li class="desclist">In the event of an injury or sickness, prior medical history may be reviewed when a claim is reported.</li>
                    <li class="desclist">The policy provides travel assistance and you are required to notify the emergency assistance provider prior to treatment. The policy limits benefits should you not contact the assistance provider within the specified time period.</li>
                    <li class="desclist">You may cancel the policy within 10 days of purchase for a full refund if you have not departed on your covered trip and there is no claim in process. For the emergency medical only plan, you may cancel any time prior to departure
                        and receive a full refund</li>
                    <li class="desclistnew">If you have any questions, you can contact us at 1-855-566-8555</li>
                </ul> -->
            </div>
            <div class="{{tabs[1].tabcontent}}" *ngIf="tabs[1].active">
                <div class="clear50"></div>
                <h1 class="descTxt semi-bold mt-3">Eligibility Requirements</h1>
                <p class="smallTxt semi-bold">Visitors to Canada – Premier Plan</p>
                <p class="desclist">All of the following restrictions apply:</p>
                <ol type="a" id="popupbullets" class="ulbulletclassOL">
                    <li class="desclist">You must be over 14 days old and under 86 years of age during the entire period of coverage.
                    </li>
                    <li class="desclist">You do not have a medical condition for which a physician has advised you against travel before your period of coverage.</li>
                    <li class="desclist">You do not have a surgically untreated aneurysm.</li>
                    <li class="desclist">You have never been diagnosed with or received treatment for:
                        <ol type="a" class="mt-2">
                            <li class="desclist">Pancreatic or liver cancer, or any type of metastasized cancer;</li>
                            <li class="desclist">A kidney condition requiring dialysis;</li>
                            <li class="desclist">A bone marrow or organ transplant;</li>
                            <li class="desclist">Congestive heart failure;</li>
                            <li class="desclist">A terminal sickness.</li>

                        </ol>

                    </li>
                    <li class="desclist">At time of purchase of this policy, you do not reside in a nursing home, assisted living home, convalescent home, hospice or rehabilitation centre.</li>
                    <li class="desclist">You do not require assistance with normal daily activities. This does not apply to children under 12 years of age.</li>
                    <li class="desclist">You have not taken (or been prescribed) oral steroids or used home oxygen to treat a lung condition in the 12 months before Your start date.</li>
                    <li class="desclist">
                        In the 12 months immediately prior to your start date you have not been:
                        <ol type="a">
                            <li class="desclist">diagnosed with or received treatment for any two conditions listed in the Medical Conditions Table;</li>
                            <li class="desclist">Admitted to hospital for any one condition in the Medical Conditions Table.
                            </li>

                        </ol>
                    </li>
                </ol>
                <table class="w-100 table-bordered roundedCorners">
                    <thead>
                        <tr>
                            <th scope="col" class="theadcolor semi-bold">MEDICAL CONDITIONS TABLE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="tbldataTXT">Coronary artery disease (including heart attack or angina)</td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">Valvular heart disease (including stenosis, regurgitation or valve replacement)
                            </td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">Heart arrhythmia (including atrial flutter, atrial fibrillation, ventricular fibrillation or use of a pacemaker)</td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">
                                A lung or respiratory condition for which daily medication has been prescribed (including inhalers)
                            </td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">
                                Diabetes requiring insulin
                            </td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">
                                Stroke or mini-stroke (TIA)
                            </td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">
                                Aneurysm
                            </td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">
                                Blood clots
                            </td>
                        </tr>
                        <tr>
                            <td class="tbldataTXT">
                                Gastro-intestinal bleed
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- <p class="smallTxt">Visitors to Canada – Premier Plan</p> --> 
                <!-- <p class="desclist">All of the following restrictions apply:</p> -->
                <!-- <p class="desclist">To be eligible for coverage under this policy, you must, as of the date you apply for coverage and the effective date:</p>
                <ul id="popupbullets" class="ulbulletclass">
                    <li class="desclist">You have not been advised by a physician to avoid travel at this time; and
                    </li>
                    <li class="desclist">You are not travelling against a physician’s advice and you have not been diagnosed with a terminal illness for which a physician has estimated you have less than six (6) months to live; and
                    </li>
                    <li class="desclist">You are 69 years of age and under at the time of application date of the policy; and 
                        <ul id="popupbullets" class="ulbulletclass mt-2">
                            <li class="desclist">You are a student enrolled in a school within Canada; or</li>
                            <li class="desclist">You are an accompanying spouse or dependent child(ren) of the student residing in Canada; and</li>
                           

                        </ul>

                    </li>
                    <li class="desclist">You are not insured under a government health insurance plan.</li>
                </ul>
                <div class="clear20"></div> -->
                <!-- <p class="desclist">To be eligible for coverage under this policy, you must, as of the date you apply for coverage and the effective date:</p> -->
                <!-- <p class="desclist"> <span class="smallTxt" style="font-weight:bold;">Student </span>means the insured person:</p>
                <ul id="popupbullets" class="ulbulletclass ">
                        <li class="desclist">Whose home country is not Canada and who is residing in Canada on a temporary basis; and
                        </li>
                        <li class="desclist ">Who:
                            <ul id="popupbullets" class="ulbulletclass mt-2">
                                <li class="desclist">Is registered at a school, college, university or other governmentally accredited education institution in Canada and attends classes as a full-time student, as defined by the institution; or</li>
                                <li class="desclist">Remains in Canada for up to one year immediately after completion of studies as described above, and who is working or has applied to work in a field related to those studies completed.</li>
                              
                            </ul>
    
                        </li>
                    </ul>

                    
                    <div class="clear20"></div>
                    <p class="desclist"><span class="smallTxt"  style="font-weight:bold;">Spouse </span>means the person who is legally married to you or the person who has been living with you for a continuous period of at least one (1) year and is publicly represented as your domestic partner.</p>
                    
                    <div class="clear20"></div>
                    <p class="desclist"> <span class="smallTxt" style="font-weight:bold;">Dependent children </span>means your unmarried natural, adopted or step-children who are dependent on you for maintenance and support, or your grandchild(ren), who are travelling with you or joining you during your trip, and who are at least thirty (30) days of age and either (i) under twenty one (21) years of age or (ii) under twenty five (25) years of age and in full-time attendance at a recognized institution of higher learning in Canada. Dependent child(ren) also includes children 21 years of age or over who are permanently mentally or physically challenged and incapable of self-support.</p>
                      -->
                    <!-- <div class="clear20"></div> -->
                    <!-- <div class="clear20"></div> -->
                    <!-- <div class="clear20"></div>
                <p class="descPara mb-3">* The above is a summary of coverage. Please refer to the policy for complete benefits, exclusions, limitations, terms and conditions.

                    Underwritten by Zurich Insurance Company Ltd. (Canadian Branch). 
                </p> -->
                <div class="clear20"></div>
            </div>


            
            <div class="{{tabs[2].tabcontent}}" *ngIf="tabs[2].active">
                <!-- <div class="clear50"></div>
                <h1 class="descTxt semi-bold mt-3">Policy Exclusions</h1>
                <p class="descPara">Exclusions can be found on the following pages -View Policy</p>
                <h1 class="descTxt semi-bold mt-3">Visitors to Canada – Premier Plan:</h1>
                <p class="descPara">Exclusions Applicable to All Policy Sections – Page 18</p> -->
                <div class="clear50"></div>
                <h1 class="descTxt mt-3">Policy Exclusions</h1>
                <p class="smallTxt">{{selectedPlanName}}</p>
                <p class="descPara">There is no coverage and no benefits will be payable for claims resulting from or attributable to:</p>
                <ol type="1" class="mt-2" id="popupbullets">
                    <li class="desclist">Pre-existing conditions or related medical conditions that existed during the 180 day period immediately prior to your start date;</li>
                    <li class="desclist">Expenses related to a sickness, injury, or medical condition that in the opinion
                         of our medical director would have caused you to seek medical advice, diagnosis, care or treatment,
                        during the 180 day period immediately prior to your start date;
                    </li>
                    <li class="desclist">Any expenses incurred outside the period of coverage;</li>
                    <li class="desclist">Any expenses incurred outside Canada except for;
                        <ol type="a" id="popupbullets">
                            <li class="desclist">if coverage is purchased prior to arrival in Canada, emergency expenses 
                                incurred en route to Canada after the date and time you leave your home country provided 
                                you are scheduled to arrive in Canada within 48 hours of departure;
                            </li>
                            <li class="desclist">if coverage is in effect on the date you leave Canada, emergency expenses 
                                incurred en route to your home country after the date and time you leave Canada provided You 
                                are scheduled to arrive in your home country within 48 hours of departure;
                            </li>
                            <li class="desclist">emergency expenses incurred during any side trip outside of Canada as 
                                described in Coverage for Side Trips Outside Canada on page 6;
                            </li>
                        </ol>
                    </li> 
                    <li class="desclist">Treatment:
                        <ol type="a">
                            <li class="desclist">not required for the immediate relief of acute pain and suffering;</li>
                            <li class="desclist">which can reasonably be delayed until your policy expires or you return to your home country;</li>
                            <li class="desclist">for follow-up treatment (other than subsequent follow-up visits per benefit 
                                1. g) on page 10), recurrence of a medical condition or subsequent emergency treatment or 
                                hospitalization for a medical condition or related medical conditions for which you had 
                                received emergency treatment during your period of coverage;
                            </li>
                        </ol>
                    </li> 
                    <li class="desclist">Transplants of any kind;</li>
                    <li class="desclist">Expenses incurred whereby this policy was purchased specifically to obtain hospital 
                        or medical treatment outside your home country whether or not recommended by your attending physician;
                    </li>
                    <li class="desclist">The cost of replenishing any medication that was in use on your departure date or 
                        for the maintenance of any course of treatment that commenced prior to your date of arrival in Canada;
                    </li>
                    <li class="desclist">Unless the company pre-approves it, emergency air transportation; surgery; diagnostic
                        testing; cardiac procedures including but not limited to cardiac catheterization, angioplasty or surgery;
                    </li>
                    <li class="desclist">Your mental, emotional or nervous disorders resulting from any cause, including but 
                        not limited to anxiety or depression;
                    </li>
                    <li class="desclist">Any treatment or services performed by a family member;</li>
                    <li class="desclist">Any elective medical treatment;</li>
                    <li class="desclist">Cataracts or any medical conditions resulting from their medical care;</li>
                    <li class="desclist">Pregnancy, childbirth, complications of pregnancy or childbirth, or voluntarily 
                        induced abortion; or a child born during your Period of Coverage.
                    </li>
                    <li class="desclist">A condition that is directly or indirectly related to any medical condition for 
                        which you have declined or delayed recommended treatment, diagnostic testing or prescription 
                        medication in the 2 years prior to the date it gives rise to a claim under this policy.
                    </li>
                    <li class="desclist">Your use of drugs, alcohol, or any medication that results directly or indirectly
                         in the condition causing a claim;
                    </li>
                    <li class="desclist">Your suicide, attempted suicide or any intentionally self-inflicted injury;</li>
                    <li class="desclist">Your participation in adventure activities;</li>
                    <li class="desclist">Your participation in organized professional sporting activities;</li>
                    <li class="desclist">Your driving a motorcycle, moped, or scooter, whether or not you are driving 
                        on publicly maintained roads, driving off-road or on private property (unless you hold an applicable 
                        valid Canadian driver’s license);
                    </li>
                    <li class="desclist">Your riding, driving or participating in races of speed or endurance;</li>
                    <li class="desclist">Your piloting an aircraft or air travel on any air supported device other than 
                        as a fare-paying passenger on a flight operated by a common carrier;
                    </li>
                    <li class="desclist">Fraud, concealment, or deliberate misstatement in relation to any matter affecting 
                        this insurance or in connection with the making of any claim hereunder;
                    </li>
                    <li class="desclist">Your participation in a crime or malicious act;</li>
                    <li class="desclist">Your participation in a riot or insurrection;</li>
                    <li class="desclist">War or act of war (whether declared or undeclared), invasion, act of foreign enemy, 
                        hostilities, civil war, rebellion, revolution, insurrection or military uprising or usurped power;
                    </li>
                    <li class="desclist">Act of terrorism by nuclear means and terrorism by dissemination of biological, 
                        chemical and or bio-chemical agents and substances;
                    </li>
                    <li class="desclist">Your participation in the armed forces;</li>
                    <li class="desclist">Orbital or sub-orbital flights;</li>
                    <li class="desclist">Events related to “Avoid Non-Essential Travel” and “Avoid All Travel” advisories 
                        issued by the Government of Canada prior to your departure on your side trip outside of Canada that 
                        were or continue to be in effect for your country, region or city of destination during your Period 
                        of Coverage, as reflected in your travel itinerary;
                    </li>
                    <li class="desclist">Contamination resulting from radioactive material or nuclear fuel or waste; or</li>
                    <li class="desclist">Any trip as a driver, operator, co-driver, crewmember, or passenger on any vehicle 
                        used to carry goods or passengers for sale, resale or income including but not limited to taxi, 
                        ride-sharing or delivery drivers.
                    </li>
                </ol>
                <div class="clear20"></div>
            </div>
            <div class="{{tabs[3].tabcontent}}" *ngIf="tabs[3].active">
                <div class="clear50"></div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-xl-12 text-right downloadbtn">
                    <div  class="fs-14 regular btn-blue" (click)="downloadPolicyWording()">Download</div>
                    </div>
                </div>
                <div class="clear10"></div>
                <!-- <iframe class="iframe" src="https://travelance.box.com/v/isp-policy-eng"  title="Policy Wording">
                </iframe> -->
                <iframe [src]='UrlBoxPolicy | sanitizePipe' height="550px" width="100%" title="Policy Wording"></iframe>
            </div>
        </div>
    </div>
  </div>
  <div id="viewPolicyDetails1" class="modal" [style.display]="viewPolicyDetailsPopup1 ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <!-- <span class="fs-16 text46 semi-bold">{{PopupPlanName}}</span> -->
            <h6 class="close text-right" (click)="viewPolicyDetailsPopup1=!viewPolicyDetailsPopup1">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
                <ul id="viewPolicyDetails1" class="posfix">
                   <li><a class="active">Policy Wording</a></li>
                    <!-- <li class="{{tabs[0].active}}" (click)="openTabs(0)"><a class="active">Description & Summary</a></li>
                    <li class="{{tabs[1].active}}" (click)="openTabs(1)"><a>Eligibility</a></li>
                    <li class="{{tabs[2].active}}" (click)="openTabs(2)"><a>Exclusions</a></li>
                    <li class="{{tabs[3].active}}" (click)="openTabs(3)"><a>Policy Wording</a></li> -->
                </ul>
                <!-- <button type="submit" class="fs-12 text-right" (click)="downloadPolicyWording()">Download</button> -->
            </div>
           
            <div>
                <div class="clear50"></div>
                <div class="clear10"></div>
                <div class="row">
                    <div class="col-xl-12 text-right downloadbtn">
                    <div  class="fs-14 regular btn-blue" (click)="downloadPolicyWording()">Download</div>
                    </div>
                </div>
                <div class="clear10"></div>
                <!-- <iframe class="iframe" src="https://travelance.box.com/v/isp-policy-eng" title="Policy Wording">
                </iframe> -->
                <iframe [src]='UrlBoxPolicy | sanitizePipe' height="550px" width="100%" title="Policy Wording"></iframe>
            </div>
        </div>
    </div>
  </div>
  <div id="saveQuotesPopup" class="modal" [style.display]="saveQuotesPopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <!-- <span class="fs-16 text46 semi-bold">Monthly Payment Schedule</span> -->
            <h6 class="close text-right" (click)="saveQuotesPopup=!saveQuotesPopup">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="fs-14 bold">
                Enter a name to help you identify this quote in the future, and click “Save Quote” to save your quote. The quote will be saved until <span class="red">{{saveQuoteDate | date:'dd MMM yyyy'}}</span>.
            </div>
            <br>
            <div class="fs-14 bold"> All quotes are based on rates in effect at the time of quote and are subject to change without notice prior to purchase.</div>
            <div class="clear20"></div>
            <label class="regular fs-16">Quote Name<span class="red">*</span></label>
            <input class="form-control forminput Tab" placeholder="Quote Name" type="text" [(ngModel)]="quoteName" (input)="quoteNameErrorRemove()">
            <p class="fs-14 regular redstar" *ngIf="quoteNameFlag">Quote name is required</p>
            <div class="clear10"></div>
            <label class="regular fs-16">Quote Description</label>
            <input class="form-control forminput Tab" placeholder="Quote Description" type="text" [(ngModel)]="quoteDescriptions">
            <div class="clear20"></div>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                    <button type="submit" class="saveQuoteBluebtn ml-1 bold" (click)="saveQuoteStage1()">Save Quote</button>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                    <button type="submit" class="EmailPrintbtn ml-1 bold" (click)="saveAndEmailQuoteStep1()">Save and Email</button>
                </div>
            </div>            
        </div>
    </div>
  </div>
  <div id="saveQuotesPopup" class="modal" [style.display]="saveQuotesPopup1 ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <!-- <span class="fs-16 text46 semi-bold">Monthly Payment Schedule</span> -->
            <h6 class="close text-right" (click)="saveQuotesPopup1=!saveQuotesPopup1">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="fs-14 bold">
                Enter a name to help you identify this quote in the future, and click “Save Quote” to save your quote. The quote will be saved until <span class="red">{{saveQuoteDate | date:'dd MMM yyyy'}}</span>.
            </div>
            <br>
            <div class="fs-14 bold"> All quotes are based on rates in effect at the time of quote and are subject to change without notice prior to purchase.</div>
            <div class="clear20"></div>
            <label class="regular fs-16">Quote Name<span class="red">*</span></label>
            <input class="form-control forminput Tab" placeholder="Quote Name" type="text" [(ngModel)]="quoteName" (input)="quoteNameErrorRemove()">
            <p class="fs-14 regular redstar" *ngIf="quoteNameFlag">Quote name is required</p>
            <div class="clear10"></div>
            <label class="regular fs-16">Quote Description</label>
            <input class="form-control forminput Tab" placeholder="Quote Description" type="text" [(ngModel)]="quoteDescriptions">
            <div class="clear20"></div>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                    <button type="submit" class="saveQuoteBluebtn ml-1 bold" (click)="step2SaveQuote()">Save Quote</button>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                    <button type="submit" class="EmailPrintbtn ml-1 bold" (click)="saveAndEmailQuoteStep2()">Save and Email</button>
                </div>
            </div>            
        </div>
    </div>
  </div>
  <div id="saveQuotesPopup" class="modal" [style.display]="saveQuotesPopup2 ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <!-- <span class="fs-16 text46 semi-bold">Monthly Payment Schedule</span> -->
            <h6 class="close text-right" (click)="saveQuotesPopup2=!saveQuotesPopup2">&times;</h6>
        </div>
        <div class="modal-body">
            <div class="fs-14 bold">
                Enter a name to help you identify this quote in the future, and click “Save Quote” to save your quote. The quote will be saved until <span class="red">{{saveQuoteDate | date:'dd MMM yyyy'}}</span>.
            </div>
            <br>
            <div class="fs-14 bold"> All quotes are based on rates in effect at the time of quote and are subject to change without notice prior to purchase.</div>
            <div class="clear20"></div>
            <label class="regular fs-16">Quote Name<span class="red">*</span></label>
            <input class="form-control forminput Tab" placeholder="Quote Name" type="text" [(ngModel)]="quoteName" (input)="quoteNameErrorRemove2()">
            <p class="fs-14 regular redstar" *ngIf="quoteNameFlag">Quote name is required</p>
            <div class="clear10"></div>
            <label class="regular fs-16">Quote Description</label>
            <input class="form-control forminput Tab" placeholder="Quote Description" type="text" [(ngModel)]="quoteDescriptions">
            <div class="clear20"></div>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                    <button type="submit" class="saveQuoteBluebtn ml-1 bold" (click)="onSaveQuote3()">Save Quote</button>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                    <button type="submit" class="EmailPrintbtn ml-1 bold" (click)="saveAndEmailQuoteStep3()">Save and Email</button>
                </div>
            </div>            
        </div>
    </div>
  </div>
 
  <div id="viewPolicyDetails" class="modal" [style.display]="privacystatementpopup ? 'block' : 'none'">
    <div class="modal-content">
        <div class="modal-header">
            <span class="fs-16 text46 semi-bold">Privacy Statement</span>
            <h6 class="close text-right" (click)="privacystatementpopup=!privacystatementpopup">&times;</h6>
        </div>
        <div class="modal-body">
           
            <div class="clear20"></div>
            <p class="descPara"> By submitting personal information, including, but not limited to, name, address, date of birth, and medical information to Travelance Inc. (“Travelance”), Zurich Insurance Company Ltd (Canadian Branch), and World Travel Protection Canada Inc. (collectively, “Zurich”), their affiliates, and authorized representatives respecting individuals insured or covered by this policy, I acknowledge and confirm that I have consented to and, if applicable, I have obtained, and am retaining the consent of the named individuals in this application for travel insurance included above, to the collection, storage, use and disclosure of their personal information for the purposes of securing and administering insurance coverage(s). I understand that Personal information may be processed and stored by Zurich, its affiliates, and authorized representatives in both domestic and foreign jurisdictions.</p>
            <div class="clear20"></div>
            <p class="descPara"> The above-named applicant (s) may refuse to consent or withdraw their consent to the collection, storage, use or disclosure of personal information; however, the refusal to provide consent may result in Travelance being unable to offer and administer insurance coverage or prevent Zurich from being able to pay claim benefits.
            </p>
            <div class="clear20"></div>
            <p class="descPara"> Zurich is committed to protecting the privacy of the information we receive about you in the course of providing the insurance you have chosen. While our employees need to have access to that information, we have taken measures to protect your privacy. We ensure that other professionals, with whom we work in giving you the services you need under your insurance, have done so as well.</p>
            <div class="clear20"></div>
            <p class="descPara"> The specific and detailed information requested on your application is required to process the application. To protect the confidentiality of this information, Zurich will establish a financial services file from which this information will be used to process the application, offer and administer services, and process claims. Access to this file will be restricted to those Zurich employees, mandataries, administrators or agents who are responsible for the assessment of risk (underwriting), marketing and administration of services and the investigation of claims, and to any other person you authorize or as authorized by law. These people, organizations and service providers may be in jurisdictions outside Canada, and subject to the laws of those foreign jurisdictions.</p>
            <div class="clear20"></div>
            <p class="descPara"> Your file is secured in Zurich’s offices or those of our administrator or agent. If you require further additional information regarding the collection, use, disclosure, processing and storage of your personal information, or you wish to review your personal information and make corrections, please contact: Privacy Officer, Zurich Insurance Company Ltd (Canadian Branch), 100 King Street West, Suite 5500, P.O. Box 290, Toronto, ON M5X 1C9.</p>           
        
              
        </div>
    </div>
  </div>
  <div id="showoutSideProvince" class="modal modal-dialog-centered" [style.display]="showOutSideProvincePopup ? 'flex' : 'none'">
    <div class="modal-content">
        <div class="modal-body">
            <div class="bold fs-14">
                Travelance does not have a current copy of your valid insurance license for this province.
            </div>
            <div class="clear10"></div>
            <div class="regular fs-14">
                Failure to hold a valid insurance license in this province will result in a commission chargeback for this sale, a reissuing of this sale under another broker licensed in this province, or the sale being assigned to Travelance.
            </div>
            <div class="clear10"></div>
            <div class="regular fs-14">
                If you are not licensed in this province and would like to continue with this sale, contact Travelance for assistance.
            </div>
            <div class="clear10"></div>
            <div class="regular fs-14">
                By clicking “Ok” I confirm that I hold the correct license to sell insurance to a purchaser residing in this province and that I will upload a copy of my license for this province to my MyTL account within 3 business days of this sale.
            </div>
            <div class="clear20"></div>
            <div class="text-right mr-5">
                <button type="button" class="fs-14 bold addbtn" (click)="showOutSideProvincePopup=!showOutSideProvincePopup">OK</button>
            </div>
        </div>
    </div>
  </div>